import React, { useEffect, useContext, useRef, useState, memo } from "react";
import { AppContext } from "../context";
import * as tf from "@tensorflow/tfjs";
import {
  PartDetector,
  setBackendExternally,
} from "../partdetection_new/PartDetector";
import {
  runCarPartDetection,
  preprocessVideo,
  // getLastVanInfo, // DEBUG (commented out)
} from "../partdetection_new/NewPartDetector";
import { Guidance } from "../guidance_new/GuidanceMain";
import drawArc from "../utils_new/DrawArc";
import {
  startCarVideoRecording,
  stopCarVideoRecordingAndUpload,
} from "../utils_new/carVideoRecorder";
import {
  getSharedInferenceWorker,
  makeLowLightFrameShim,
} from "../utils_new/inferenceWorkerClient";
import carsmall from "../img/carsmall.png";
import conjustedImg from "../img/conjusted.png";
import instImg from "../img/instImg.svg";
import initRedImg from "../img/coverage_red.png";
import nearFarArrow from "../img/zizo_arrow.gif";
import Rotate from "./Rotate";
import {
  addImageToList,
  sendCoveredArea,
  setLog,
  actualRegion,
  userLogs,
  patLogs,
  getModel,
  resumeFlowFinalSubmitHandler,
  setImgCOunt,
  getConstraint,
  getAspectRatioClientList,
  getLumaBlurScore,
  getWebpImageFormat,
  getImgQualityFactor,
  setAllSideCoveredVideo,
  getRedirectVideoToImgFlag,
  setPortoModuleComplete,
  filterPortoModuleList
} from "../context/utils";

import * as constants from "../utils_new/Constants";
import { goodFrame } from "../guidance_new/Stencil";
import {
  initTelemetry,
  logModelInitStart,
  logModelInitEnd,
  recordInference,
  recordAngle,
  recordDial,
  flushDial,
} from "../utils_new/videoTelemetry";

import Front from "./Stencils/car/Front";
import Front_Isometric_Left from "./Stencils/car/Front-Isometric-Left";
import Front_Isometric_Right from "./Stencils/car/Front-Isometric-Right";
import Side_Left from "./Stencils/car/Side-Left";
import Side_Right from "./Stencils/car/Side-Right";
import Rear from "./Stencils/car/Rear";
import Rear_Isometric_Right from "./Stencils/car/Rear-Isometric-Right";
import Rear_Isometric_Left from "./Stencils/car/Rear-Isometric-Left";
import Side_Left_Back from "./Stencils/car/Side-Left-Back";
import Side_Left_Front from "./Stencils/car/Side-Left-Front";
import Side_Right_Back from "./Stencils/car/Side-Right-Back";
import Side_Right_Front from "./Stencils/car/Side-Right-Front";
import StencilInst from "./Stencils/stenciInst.svg";
import HoldSvg from "./Stencils/hold.svg";
import { get } from "underscore";
import { startVideoPlayback } from "../utils_new/videoPlayback";
import SafeImage from "./SafeImage";
import {
  setTorchTrack,
  resetTorch,
  checkFrameForTorch,
} from "../utils_new/torchController";
import {
  setBlurFromConfig,
  resetBlur,
  isBlurMode,
  checkFrameForBlur,
  noteBlockedUpload,
  sampleFrameForBlurWindow,
  takeBlurWindow,
} from "../utils_new/blurController";
import BlurLensModal from "./BlurLensModal";
import TorchModeControl from "./TorchModeControl";

const MemoizedStencil = memo(({ Component, color }) => {
  return <Component strokeColor={color} />;
});

const tinyCanvas = document.createElement("canvas");
tinyCanvas.width = 64;
tinyCanvas.height = 64;
const tinyCtx = tinyCanvas.getContext("2d", { willReadFrequently: true });

let regionStencil = {
  Front: Front,
  "Front-Isometric-Left": Front_Isometric_Left,
  "Side-Left": Side_Left,
  "Rear-Isometric-Left": Rear_Isometric_Left,
  Rear: Rear,
  "Rear-Isometric-Right": Rear_Isometric_Right,
  "Side-Right": Side_Right,
  "Front-Isometric-Right": Front_Isometric_Right,
};

// viewBox [width, height] of each congested sub-stencil SVG. The subs are
// portrait and rendered with "xMidYMax meet", so their visible width is narrower
// than the full video box — this lets us size the fit-box to the actual stencil.
const subStencilViewBox = {
  "Side-Left-Front": [60.4, 95.3],
  "Side-Right-Front": [60.4, 95.3],
  "Side-Left-Back": [71.6, 88.9],
  "Side-Right-Back": [71.6, 88.9],
};

// Horizontal offset from centre for each congested sub-stencil, as a signed
// fraction of the stencil's OWN rendered width (negative = left, positive =
// right). Within each side the two halves sit on opposite sides of centre: on
// the left side the front half sits right and the back half left; on the right
// side the front half sits left and the back half right. Applied to the
// .stencil box itself (which the sub-stencil SVG fills), so the visible artwork
// and the detection fit-box (topLeft/bottomRight) move together and stay 1:1.
const subStencilShiftX = {
  "Side-Left-Front": 0.2,
  "Side-Left-Back": -0.2,
  "Side-Right-Front": -0.2,
  "Side-Right-Back": 0.2,
};

const vinRegion = [
  "Front",
  "Front-Isometric-Left",
  "Side-Left",
  "Rear-Isometric-Left",
  "Rear",
  "Rear-Isometric-Right",
  "Side-Right",
  "Front-Isometric-Right",
  "Front",
];

let regionIcon = {
  Front:
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front.svg",
  "Front-Isometric-Right":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front+right.svg",
  "Side-Right":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Right.svg",
  "Rear-Isometric-Right":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back+right.svg",
  Rear: "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back.svg",
  "Rear-Isometric-Left":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Back+left.svg",
  "Side-Left":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Left.svg",
  "Front-Isometric-Left":
    "https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/-_Front+left.svg",
};

let stencilImageDivRunOnce = true;
let missedstep = false;
let logbugs = true;
let regionsAndAnglesMap = {};
for (let val of Object.values(constants.REGIONS))
  regionsAndAnglesMap[val] = new Set();
let allActualRegionDataLog = {};
let allActualRegionDataLogsCheck = {};
let finalRegionsMap = {};
let captured = 0;
let allActualRegionData = {};
let actualGuidanceRegion;
let seconds = 0;
let minutes = 0;
let WholeLightLumaData = "";
let data = {};
let track = null;
let angleDetectedGyro = [];
let currentUploadedPartCount = null;
let detectMlCheck = true;
// Cap on the detect-loop iteration rate (same recipe as NewVideo): with
// inference off the main thread the loop is no longer throttled by
// executeAsync, and every iteration pays captureImgFrame on the main thread.
// Override per client via config["video-page"]["detectIntervalMs"].
let lastDetectIterationTs = 0;
let minDetectIntervalMs = 250;
let imgValue = 0;
let afterFrameimgValue = 0;
let stopRecordingML = false;
let allowImgURLmain = {};
let regionWiseData = {};
let allFrameUpload = false;
let checkOnceRegion = true;
let hold = true;
let hold2 = true;
let currentStencil = "";
let showCoveredRegion = {};
let showCoveredRegioncheck = {};
let staticRegion = "";
let frameUploadStencil = false;
let captureStencilDialGrren = [];
let captureStencilDialRed = [];
let imageFrameInterval;
let frameInterval;
let stencilCheckInterval;
let InstructionClear;
let checkLumaValue = true;
let startRefCheck;
let checkImageList = [];
let checkImageList2 = [];
let checkImageList3 = [];
let lastSharpCheck = 0;
let previousAngle = [
  0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 140, 150, 160, 170,
  180, 190, 200, 210, 220, 230, 240, 250, 260, 270, 280, 290, 300, 310, 320,
  330, 340, 350, 360,
];
let detectionFuncTime = 3;
let lastLayoutRegion = null;
let lastLayoutWidth = 0;
let lastLayoutHeight = 0;

/*
 * Stencil capture, when blur gating is on.
 *
 * The two moments a stencil changes colour are the two moments frames are kept,
 * so they are the only moments worth judging -- there is no per-frame check in
 * here at all, unlike the 360 video. Each of them takes two shots and proves
 * both sharp before either is uploaded and before the colour is allowed to
 * change.
 *
 * Half a second between the two is the point of the pair. Two frames taken back
 * to back are the same frame twice over -- same tremor, same focus hunt -- so
 * they are one shot's worth of evidence. 500ms is long enough for the camera to
 * have moved on and refocused, and short enough that the user is still holding
 * the position they were asked to hold.
 *
 * A blurry shot is discarded and another taken in its place, but not forever:
 * after STENCIL_SHOT_ATTEMPTS tries the sharpest frames seen are used anyway. A
 * stencil the user can never get past would be worse than a soft photograph of
 * one.
 */
const STENCIL_SHOTS = 2;
const STENCIL_SHOT_GAP_MS = 500;
const STENCIL_SHOT_ATTEMPTS = 8;

// One collection at a time. Both transitions can fire on the same frame, and
// two analyses in flight together would hand one of them the other's verdict.
let stencilShotQueue = Promise.resolve();
const runStencilShots = (fn) => {
  const next = stencilShotQueue.then(fn, fn);
  stencilShotQueue = next.then(
    () => undefined,
    () => undefined,
  );
  return next;
};

const waitMs = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

let startTimeModel = 0;
let consoleOnceModel = true;
let getTimeonce = true;
let detectOnce = true;
// let coldStartOnce = true; // DEBUG (commented out)
// NEW VARIABLES TO HOLD STATIC LOGS
let coldStartText = "";
let regionDetectedText = "";
let currentVisibleStencilEl = null;
let firstSideVisited = null;

const StencilVideo = () => {
  const {
    skipStencil,
    setSkipStencil,
    alignStencil,
    setalignStencil,
    capturedStencil,
    setcapturedStencil,
    stepCovered,
    setStepCovered,
    setScreen,
    currentBlock,
    condition,
    setCondition,
    config,
    token,
    mandatory,
    setMandatory,
    inspectionId,
    setStopPing,
    setCurrentPage,
    stopPing,
    restrictUserIfallNotGreen,
    setRestrictUserIfallNotGreen,
    clientId,
    caseId,
    isIOS,
    setFallbackCondition,
    setFallbackSubCondition,
    setFallbackMandatory,
    setFallbackSubMandatory,
    setFallbackBlockId,
  } = useContext(AppContext);

  // Congested-area capture is opt-in per client. With the flag unset or false
  // the two side regions capture as one stencil each, exactly as before: the
  // "congested area?" prompt never opens, so congestedRef stays inactive and
  // every sub-stencil path downstream (which all test cr.active) stays dormant.
  // Both spellings are accepted: "congested" is the correct one and what new
  // client configs should use, "conjusted" is the original misspelling and is
  // kept working for configs already deployed with it.
  const congestedEnabled = Boolean(config["congested"] || config["conjusted"]);

  let frameResolution =
    Object.keys(config).includes("int8Model") && config["int8Model"]
      ? 320
      : 128;

  const [mainRegion, setmainRegion] = useState("");
  const [lumacheck, setLumaCheck] = useState(false);
  const [holdSkip, setHoldSkip] = useState(true);
  const [errorType, setErrorType] = useState(false);
  // Raised when a whole window of frames came back blurry -- see the call to
  // takeBlurWindow in the detection loop.
  const [lensDirty, setLensDirty] = useState(false);

  const stateTrackers = useRef({
    activeStencil: null,
    stencilColor: "#fff",
    isStencilVisible: false,
  });

  const timerRef = useRef();
  const videoRef = useRef();
  const canvasRef = useRef();
  const cardRef = useRef();
  const screen3 = useRef();
  const stencilImageDiv = useRef();
  const loaderGuidanceText = useRef();
  const imgRef = useRef();
  const startRef = useRef();
  const warnRef = useRef();
  const canvas1 = useRef();
  const chooseRegionStencil = useRef();
  const holdImage = useRef();
  const partDetectorRef = useRef(null);
  if (!partDetectorRef.current) partDetectorRef.current = new PartDetector();
  const partDetector = partDetectorRef.current;

  const guidanceRef = useRef(null);
  if (!guidanceRef.current) {
    guidanceRef.current = new Guidance(
      config["video-page"]["guidanceMessages"],
      clientId,
      config,
    );
    // Start the dial fresh (all NOT_COVERED) on each mount. The dial is driven
    // solely by the explicit capture flow (captureStencilDialGrren /
    // captureStencilDialRed), so it must NOT be aliased to
    // guidance.regionsCoveredMap — see the showCoveredRegion note below.
    showCoveredRegion = {};
    for (let val of Object.values(constants.REGIONS))
      showCoveredRegion[val] = constants.REGION_COVERAGE_STATUS.NOT_COVERED;
  }
  const guidance = guidanceRef.current;

  const displayText = useRef();
  const detectionBox = useRef();
  // const inferenceTimeRef = useRef(); // DEBUG (commented out)
  // const modelInitTimeRef = useRef(); // DEBUG (commented out)
  // const coldStartTimeRef = useRef(); // DEBUG (commented out)
  // const detectionLogRef = useRef(); // DEBUG (commented out)
  // const vanFlagRef = useRef(); // DEBUG (commented out)
  // const partData = useRef();
  // const partDataValue = useRef();
  // const partDataValueList = useRef();
  const leftNearArrow = useRef();
  const rightNearArrow = useRef();
  const leftFarArrow = useRef();
  const rightFarArrow = useRef();
  const leftArrowVin = useRef();
  const rightArrowVin = useRef();
  const downArrow = useRef();
  const upArrow = useRef();
  const skipDiv = useRef();
  const resizeCanvasRef = useRef(null);
  const resizeCtxRef = useRef(null);
  const confirmSkipDiv = useRef();
  const showResult = useRef();
  const instImage = useRef();
  const skipDivFallback = useRef();
  const congestedAreaDiv = useRef();
  const congestedSubDiv = useRef();
  const congestedRef = useRef({
    active: false,
    parentRegion: "",
    keys: [], // ["Side-Right-Front", "Side-Right-Back"] — stencil div IDs
    currentIdx: 0,
    results: [null, null], // per sub: 'green' | 'blue' | 'white'
  });

  data = {
    text: config["video-page"]["dataText"],
    feedbacks: [],
    regionsCovered: guidance.regionsCoveredMap,
    angle: 0,
    region: "",
    nudges: { partToPoint: "", Nudge: "" },
  };
  // Intentionally NOT aliased to guidance.regionsCoveredMap. The dial must show
  // ONLY the user's explicit capture flow; aliasing let the guidance engine's
  // automatic part detection light up neighbouring/skipped regions (e.g.
  // Front-Isometric-Left turning blue while capturing the Side-Left front
  // sub-stencil, because the left fender is seen at the frame edge).
  // guidance.regionsCoveredMap still drives data.regionsCovered above for the
  // image-fallback checks. Guard against an empty map (e.g. hot reload).
  if (Object.keys(showCoveredRegion).length === 0) {
    for (let val of Object.values(constants.REGIONS))
      showCoveredRegion[val] = constants.REGION_COVERAGE_STATUS.NOT_COVERED;
  }

  const getTranslateText = (text) => {
    if (Object.keys(config["language"]).includes(text))
      return config["language"][text];
    else return text;
  };

  // Same two-tier lookup the JSX already does inline everywhere: a client's
  // per-page override in config["video-page"] wins, otherwise fall back to the
  // shared language dictionary. Named so a dynamic key can be looked up without
  // repeating the ternary.
  const getPageText = (key) =>
    Object.keys(config["video-page"]).includes(key)
      ? config["video-page"][key]
      : getTranslateText(key);

  const ua = navigator.userAgent.toLowerCase();
  const isIos = !!/iPhone|iPad|iPod/i.test(ua);
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
  let webCamPromise = null;
  let model = null;
  let active = true;
  let images = [];
  let endTimer = 0;
  let modalFlag = false;
  let startTimer = null;
  let allRegionsCovered = false;
  let allGreen = false;
  let detections = [];

  const isLandscape = () => window.innerWidth > window.innerHeight * 1.2;
  if (logbugs) {
    initTelemetry(inspectionId);
    patLogs("Entered to Video module", inspectionId);
    userLogs({ position: 8, last_page: "stencil video module", inspectionId });
  }
  logbugs = false;

  const sendLogData = async (data) => userLogs(data);
  const getAllFrameUpload = () => allFrameUpload;

  const uploadImg = (imgURL) => {
    imgValue = imgValue + 1;
    let region = Object.keys(config["video-page"]).includes("clientRegion")
      ? config["video-page"]["clientRegion"]
      : "eu-central-1";

    addImageToList({
      name: `${captured}.jpg`,
      imgData: imgURL,
      tag: data.region,
      angle: data.angle,
      web_region: data.region,
      env: 1,
      region: region,
      videoData: "",
      dialStatus: finalRegionsMap,
    });
    captured++;
  };

  const uploadImgInterim = (imgURL) => {
    imgValue = imgValue + 1;
    let region = Object.keys(config["video-page"]).includes("clientRegion")
      ? config["video-page"]["clientRegion"]
      : "eu-central-1";
    addImageToList({
      name: `${captured}.jpg`,
      imgData: imgURL,
      tag: `${data.region}_interim`,
      angle: data.angle,
      web_region: data.region,
      region: region,
      env: 1,
      videoData: "",
      dialStatus: finalRegionsMap,
    });
    captured++;
  };

  const setMandatoryCondition = async () => {
    let tempCondition = condition,
      tempMandatory = mandatory,
      tempSubMandatoryCondtion = subMandatory,
      tempSubCondtion = subCondition;

    //console.log("mandatory in kiwi :: ", tempCondition, tempMandatory, tempSubMandatoryCondtion, tempSubCondtion)
    tempCondition[IMG360CONFIG["id"]] = "pending";
    setFallbackCondition(tempCondition);

    let temp2Condition = condition, temp2Mandatory = mandatory;
    if (Object.keys(temp2Condition).includes(IMG360CONFIG["id"])) delete temp2Condition[IMG360CONFIG["id"]];
    setCondition(temp2Condition);

    tempMandatory[IMG360CONFIG["id"]] = "pending";
    setFallbackMandatory(tempMandatory);

    if (Object.keys(temp2Mandatory).includes(IMG360CONFIG["id"])) delete temp2Mandatory[IMG360CONFIG["id"]];
    setMandatory(temp2Mandatory);

    tempSubMandatoryCondtion[IMG360CONFIG["id"]] = {};
    tempSubCondtion[IMG360CONFIG["id"]] = {};
    IMG360CONFIG.values.map((item2) => {
      tempSubMandatoryCondtion[IMG360CONFIG["id"]][item2.name] = "pending";
      tempSubCondtion[IMG360CONFIG["id"]][item2.name] = "pending";
    });

    setFallbackSubCondition(tempSubCondtion);
    setFallbackSubMandatory(tempSubMandatoryCondtion);
    setFallbackBlockId(currentBlock["id"])
    //console.log("current block seet ::  ", currentBlock["id"], condition, mandatory, tempCondition, tempMandatory, tempSubMandatoryCondtion, tempSubCondtion)
  };

  const captureImgFrame = (byPassBlack) => {
    const cnv = canvasRef.current;
    const vw = videoRef.current;

    if (!cnv || !vw || vw.videoWidth === 0 || vw.videoHeight === 0) {
      return false;
    }

    cnv.width = vw.videoWidth;
    cnv.height = vw.videoHeight;

    const ctx = cnv.getContext("2d", { willReadFrequently: true });
    if (!ctx) return false;

    ctx.drawImage(vw, 0, 0, cnv.width, cnv.height);

    return cnv.toDataURL("image/jpeg", 0.9);
  };

  /**
   * Take `wanted` shots STENCIL_SHOT_GAP_MS apart and hand back the ones worth
   * uploading. See the constants at the top of the file for why two, and why
   * half a second.
   *
   * A shot judged blurry is dropped and another is taken in its place. If the
   * attempts run out first, the least blurry frames seen are returned rather
   * than nothing, so a soft camera slows the stencil down but never blocks it.
   *
   * `detections` are the ones from the frame that triggered the transition. They
   * crop the analysis to the car, which matters here: a stencil shot is framed
   * to fill the box, so judging the whole frame would put road and sky on the
   * jury and fail shots whose car is perfectly sharp. They go stale by up to a
   * couple of seconds, which is harmless while the user holds the position.
   *
   * `shouldAbort` is polled between shots so a collection can be cut short when
   * the flow has moved past the thing it was collecting for.
   */
  const collectBestShots = async (wanted, region, detections, shouldAbort) => {
    const sharp = [];
    const seen = [];

    for (
      let attempt = 0;
      attempt < STENCIL_SHOT_ATTEMPTS && sharp.length < wanted;
      attempt++
    ) {
      if (attempt > 0) {
        await waitMs(STENCIL_SHOT_GAP_MS);
        if (shouldAbort && shouldAbort()) break;
      }

      const shot = captureImgFrame(true);
      if (!shot) continue;

      const verdict = await checkFrameForBlur(
        shot,
        detections || [],
        videoRef.current ? videoRef.current.videoWidth : 0,
        videoRef.current ? videoRef.current.videoHeight : 0,
        region,
      );
      // No verdict at all, or one that could not be reached, means the shot is
      // not KNOWN to be blurry. Those count as good: a check that cannot run is
      // never a reason to withhold an image.
      const judged = !!(verdict && !verdict.unknown);
      if (judged && verdict.blurred) {
        noteBlockedUpload(region);
        seen.push({
          shot,
          cells: verdict.blurryCells,
          score: verdict.blurScore,
        });
      } else {
        sharp.push(shot);
      }
    }

    if (sharp.length >= wanted) return sharp.slice(0, wanted);

    // Short of sharp shots. Top up from the blurry ones, least blurry first:
    // fewest blurry cells, and the sharpest of those.
    const fallback = seen
      .sort((a, b) => a.cells - b.cells || b.score - a.score)
      .map((entry) => entry.shot);
    return sharp.concat(fallback).slice(0, wanted);
  };

  const setupVideoWithStencilBox = (currentRegion) => {
    const videoEl = videoRef.current;
    if (!videoEl || !stencilImageDiv?.current) return false;

    const containerWidth = window.innerWidth;
    const containerHeight = window.innerHeight;
    const vW = videoEl.videoWidth;
    const vH = videoEl.videoHeight;
    if (!vW || !vH) return false;

    const videoAspect = vW / vH;
    const containerAspect = containerWidth / containerHeight;
    let displayWidth, displayHeight;
    if (videoAspect > containerAspect) {
      displayWidth = containerWidth;
      displayHeight = containerWidth / videoAspect;
    } else {
      displayHeight = containerHeight;
      displayWidth = containerHeight * videoAspect;
    }

    const xOff = (containerWidth - displayWidth) / 2;
    const yOff = (containerHeight - displayHeight) / 2;

    // For the four congested sub-stencils, make the red-bordered container trace
    // the EXACT same rectangle as the detection fit-box (topLeft/bottomRight) in
    // updateStencilValue — same renderedW/renderedH, insets and bottom-anchoring.
    // This way the visible red box corresponds 1:1 to the topLeft/bottomRight
    // coordinates. Main stencils keep the full-width box.
    let boxWidth = displayWidth;
    let boxLeft = xOff;
    let boxHeight = displayHeight;
    let boxTop = yOff;
    const subVb = subStencilViewBox[currentRegion];
    if (subVb) {
      const [vbW, vbH] = subVb;
      const scale = Math.min(displayWidth / vbW, displayHeight / vbH);
      const renderedW = vbW * scale;
      const renderedH = vbH * scale;
      boxWidth = renderedW - 40;
      boxLeft =
        (containerWidth - renderedW) / 2 +
        20 +
        renderedW * (subStencilShiftX[currentRegion] || 0);
      boxHeight = renderedH - 45;
      boxTop = yOff + (displayHeight - renderedH) + 22.5;
    }

    const box = stencilImageDiv.current;
    box.style.left = `${boxLeft}px`;
    box.style.top = `${boxTop}px`;
    box.style.width = `${boxWidth}px`;
    box.style.height = `${boxHeight}px`;
    box.style.display = "flex";
    box.style.alignItems = "flex-end";
    box.style.justifyContent = "center";
    return true;
  };

  const calculateUserPositions = (variable, constant) => {
    const variableIndex = vinRegion.indexOf(variable);
    const constantIndex = vinRegion.indexOf(constant);
    let res;
    if (variableIndex === -1 || constantIndex === -1) {
      res = "undefined";
    } else {
      const totalRegions = vinRegion.length;
      const clockwiseDistance =
        (constantIndex - variableIndex + totalRegions) % totalRegions;
      const counterClockwiseDistance =
        (variableIndex - constantIndex + totalRegions) % totalRegions;
      if (clockwiseDistance === 0 || counterClockwiseDistance === 0)
        res = "same";
      else if (clockwiseDistance < counterClockwiseDistance) res = "left";
      else if (counterClockwiseDistance < clockwiseDistance) res = "right";
      else res = "left";
    }
    return res;
  };

  const updateStencilDOM = (targetStencil, isVisible, color) => {
    if (
      currentVisibleStencilEl &&
      currentVisibleStencilEl.id !== `stencil-${targetStencil}`
    ) {
      currentVisibleStencilEl.style.opacity = "0";
      currentVisibleStencilEl.style.visibility = "hidden";
      currentVisibleStencilEl = null;
    }

    if (isVisible && targetStencil) {
      const el = document.getElementById(`stencil-${targetStencil}`);
      if (el) {
        el.style.opacity = "1";
        el.style.visibility = "visible";
        el.style.setProperty("--stencil-color", color);

        const shapes = el.querySelectorAll("[stroke]");
        for (let i = 0; i < shapes.length; i++) {
          shapes[i].setAttribute("stroke", color);
        }
        currentVisibleStencilEl = el;
      }
    } else if (!isVisible && currentVisibleStencilEl) {
      currentVisibleStencilEl.style.opacity = "0";
      currentVisibleStencilEl.style.visibility = "hidden";
      currentVisibleStencilEl = null;
    }
  };

  const hideAllArrows = () => {
    upArrow.current.style.display = "none";
    downArrow.current.style.display = "none";
    leftFarArrow.current.style.display = "none";
    rightFarArrow.current.style.display = "none";
    leftNearArrow.current.style.display = "none";
    rightNearArrow.current.style.display = "none";
  };

  const advanceCapturedRegion = (region) => {
    setcapturedStencil((prevCaptured) => {
      const updated = [...prevCaptured, region];
      setalignStencil((prevAlign) => {
        const next = prevAlign.filter((item) => !updated.includes(item));
        if (updated.length > 1) {
          setmainRegion(next[0]);
          currentStencil = next[0];
        }
        return next;
      });
      if (updated.length === 1 && missedstep === false) {
        currentStencil = "";
        chooseRegionStencil.current.style.display = "flex";
      }
      if (updated.length > 7) {
        currentStencil = "";
        chooseRegionStencil.current.style.display = "flex";
        hideAllArrows();
        displayText.current.innerHTML = "";
        displayText.current.style.display = "none";
      }
      return updated;
    });
  };

  const advanceSkippedRegion = (region) => {
    setcapturedStencil((prevCaptured) => {
      const updated = [...prevCaptured, region];
      setalignStencil((prevAlign) => {
        const next = prevAlign.filter((item) => !updated.includes(item));
        if (updated.length > 1) {
          setmainRegion(next[0]);
          currentStencil = next[0];
          stateTrackers.current.stencilColor = "#fff";
          updateStencilDOM(next[0], true, "#fff");
        }
        return next;
      });
      if (updated.length === 1) {
        currentStencil = "";
        chooseRegionStencil.current.style.display = "flex";
      }
      if (updated.length > 7) {
        currentStencil = "";
        chooseRegionStencil.current.style.display = "flex";
      }
      return updated;
    });
  };

  // Congested mode: derive which half of the side to capture FIRST from where
  // the user came from (the most recently captured/skipped stencil). Coming
  // from the front of the car (Front / Front-Isometric-*) the front half is
  // nearest -> capture Side-*-Front first, then Side-*-Back; coming from the
  // rear (Rear / Rear-Isometric-*) -> Side-*-Back first, then Side-*-Front.
  // Returns null when the direction can't be determined (nothing captured
  // yet, or the last stencil was another side) -- the caller then falls back
  // to the existing manual "select which part" popup.
  const getAutoCongestedOrder = () => {
    const last = capturedStencil[capturedStencil.length - 1];
    if (!last) return null;
    const frontKey =
      mainRegion === "Side-Right" ? "Side-Right-Front" : "Side-Left-Front";
    const backKey =
      mainRegion === "Side-Right" ? "Side-Right-Back" : "Side-Left-Back";
    if (last === "Front" || last.startsWith("Front-Isometric"))
      return [frontKey, backKey];
    if (last === "Rear" || last.startsWith("Rear-Isometric"))
      return [backKey, frontKey];
    return null;
  };

  // Decide the parent side's dial color ONCE, after BOTH congested sub-stencils
  // are done. results = [sub0, sub1] where each is "green" | "blue" | "white".
  //   both green                 -> green
  //   at least one green or blue -> blue
  //   both white (no detection)  -> grey (uncovered)
  // Nothing colors the parent on the dial until this runs.
  const finalizeCongestedDial = (region, results) => {
    // Clear any stale entries first.
    captureStencilDialRed = captureStencilDialRed.filter(
      (item) => item !== region,
    );
    captureStencilDialGrren = captureStencilDialGrren.filter(
      (item) => item !== region,
    );

    const bothGreen = results[0] === "green" && results[1] === "green";
    const anyActivity = results.some((r) => r === "green" || r === "blue");

    if (bothGreen) {
      captureStencilDialGrren = [...captureStencilDialGrren, region];
    } else if (anyActivity) {
      captureStencilDialRed = [...captureStencilDialRed, region];
    } else if (
      showCoveredRegion &&
      Object.keys(showCoveredRegion).includes(region)
    ) {
      // both white -> uncovered; also reset the live coverage map in case the
      // guidance engine marked it on its own.
      showCoveredRegion[region] = 0;
    }
  };

  const skipButton = () => {
    const cr = congestedRef.current;

    clearInterval(imageFrameInterval);
    clearTimeout(stencilCheckInterval);
    stencilCheckInterval = null;
    frameUploadStencil = false;

    // A side region can leave the "Are you in a congested area?" / "Select which
    // part" modal open (the user can skip without answering it). Those modals are
    // position:fixed/zIndex:10 and would cover the final summary popup, so always
    // dismiss them when skipping.
    if (congestedAreaDiv.current)
      congestedAreaDiv.current.style.display = "none";
    if (congestedSubDiv.current) congestedSubDiv.current.style.display = "none";

    if (cr.active && currentStencil === cr.parentRegion) {
      // Record this sub's outcome — keep "blue"/"green" if it was detected,
      // otherwise it was skipped white (no detection).
      if (
        cr.results[cr.currentIdx] !== "blue" &&
        cr.results[cr.currentIdx] !== "green"
      ) {
        cr.results[cr.currentIdx] = "white";
      }

      if (cr.currentIdx === 0) {
        // First sub skipped — switch to the second sub. The parent's dial color
        // is decided only after BOTH subs are done, so don't touch the dial.
        cr.currentIdx = 1;
        updateStencilDOM(cr.keys[1], true, "#fff");
        skipDiv.current.style.display = "none";
        hold = true;
        hold2 = true;
        stencilImageDivRunOnce = true;
        checkLumaValue = true;
        return;
      } else {
        // Second sub skipped — both subs decided, set the dial color now.
        cr.active = false;
        // A skip always means the side was NOT captured, so it must appear in the
        // missed list — even if it briefly flickered blue (hold2 === false) while
        // skimming past. Dedup keeps it from being added twice.
        setSkipStencil((e) =>
          e.includes(currentStencil) ? e : [...e, currentStencil],
        );
        finalizeCongestedDial(currentStencil, cr.results);
        advanceSkippedRegion(currentStencil);
        skipDiv.current.style.display = "none";
        hold = true;
        hold2 = true;
        stencilImageDivRunOnce = true;
        checkLumaValue = true;
        return;
      }
    }

    // Normal skip flow
    // A skip always means the region was NOT captured, so always record it in the
    // missed list (regardless of hold2 / a brief blue partial-detection). Dedup
    // prevents duplicates.
    setSkipStencil((e) =>
      e.includes(currentStencil) ? e : [...e, currentStencil],
    );
    advanceSkippedRegion(currentStencil);
    skipDiv.current.style.display = "none";
    hold = true;
    hold2 = true;
    stencilImageDivRunOnce = true;
    checkLumaValue = true;
  };

  const continueButton = () => {
    hold = true;
    hold2 = true;
    stencilCheckInterval = null;
    skipDiv.current.style.display = "none";
  };

  const getLumaRes = async (img) => {
    let payload = {
      env: 1,
      region: "eu-central-1",
      inspection_id: inspectionId,
      client_id: clientId,
      image:
        getWebpImageFormat() && !isIOS
          ? img.replace(/^data:image\/webp;base64,/, "")
          : img.replace(/^data:image\/jpeg;base64,/, ""),
    };
    let value = await getLumaBlurScore(payload);
    if (
      typeof value === "object" &&
      value !== null &&
      !Array.isArray(value) &&
      Object.keys(value).length > 0 &&
      Array.isArray(value[Object.keys(value)[0]]) &&
      typeof value[Object.keys(value)[0]][1] === "number" &&
      value[Object.keys(value)[0]][1] < 2 &&
      !value[Object.keys(value)[0]][1] === 0
    ) {
      if (
        chooseRegionStencil.current.style.display === "flex" ||
        skipDiv.current.style.display === "flex"
      )
        return;

      setLumaCheck(true);
      hold = false;

      stateTrackers.current.activeStencil = null;
      stateTrackers.current.isStencilVisible = false;
      updateStencilDOM(null, false, "#fff");

      hideAllArrows();
      displayText.current.innerHTML = "";
      displayText.current.style.display = "none";
      holdImage.current.style.display = "none";
      skipDiv.current.style.display = "flex";
    }
  };

  const getMaxItem = (arr) => {
    const freq = {};
    for (const item of arr) {
      freq[item] = (freq[item] || 0) + 1;
    }
    let maxItem = null;
    let maxCount = 0;
    for (const item in freq) {
      if (freq[item] > maxCount) {
        maxCount = freq[item];
        maxItem = Number(item);
      }
    }
    return maxItem;
  };

  const drawBoxWithDiv = (topLeft, bottomRight, color) => {
    const screenW = window.innerWidth;
    const screenH = window.innerHeight;
    const videoEl = videoRef.current;
    const videoAspect =
      videoEl && videoEl.videoWidth && videoEl.videoHeight
        ? videoEl.videoWidth / videoEl.videoHeight
        : 16 / 9;
    const screenAspect = screenW / screenH;
    let displayW, displayH, xOff, yOff;
    if (videoAspect > screenAspect) {
      displayW = screenW;
      displayH = screenW / videoAspect;
      xOff = 0;
      yOff = (screenH - displayH) / 2;
    } else {
      displayH = screenH;
      displayW = screenH * videoAspect;
      xOff = (screenW - displayW) / 2;
      yOff = 0;
    }

    const originalTopLeft = [
      xOff + (topLeft[0] / frameResolution) * displayW,
      yOff + (topLeft[1] / frameResolution) * displayH,
    ];

    const originalBottomRight = [
      xOff + (bottomRight[0] / frameResolution) * displayW,
      yOff + (bottomRight[1] / frameResolution) * displayH,
    ];
    detectionBox.current.style.display = "flex";
    const [x1, y1] = originalTopLeft;
    const [x2, y2] = originalBottomRight;

    const width = x2 - x1;
    const height = y2 - y1;

    // Create a new box div
    const box = document.createElement("div");
    box.style.position = "absolute";
    box.style.left = `${x1}px`;
    box.style.top = `${y1}px`;
    box.style.width = `${width}px`;
    box.style.height = `${height}px`;
    box.style.border = `2px solid ${color}`;
    box.style.boxSizing = "border-box";

    // Append to container
    detectionBox.current.appendChild(box);
  };

  const updateStencilValue = (
    currentRegion,
    detections,
    realGyroAngle,
    currentAngle,
    subStencil = "",
  ) => {
    if (
      chooseRegionStencil.current.style.display === "flex" ||
      skipDiv.current.style.display === "flex" ||
      confirmSkipDiv.current.style.display === "flex" ||
      congestedAreaDiv.current?.style.display === "flex" ||
      congestedSubDiv.current?.style.display === "flex"
    )
      return;

    if (checkOnceRegion) {
      checkOnceRegion = false;
      currentStencil = currentRegion;
    }

    if (currentRegion && currentStencil) {
      if (checkLumaValue && hold) {
        let imgValue = captureImgFrame(true);
        if (imgValue) {
          checkLumaValue = false;
        }
      }

      if (
        lastLayoutRegion !== currentRegion ||
        lastLayoutWidth !== window.innerWidth ||
        lastLayoutHeight !== window.innerHeight
      ) {
        const ok = setupVideoWithStencilBox(currentRegion);
        if (ok) {
          lastLayoutRegion = currentRegion;
          lastLayoutWidth = window.innerWidth;
          lastLayoutHeight = window.innerHeight;
        }
      }

      const cr = congestedRef.current;
      const activeStencilKey =
        cr.active && currentStencil === cr.parentRegion
          ? cr.keys[cr.currentIdx]
          : currentStencil;

      if (
        stateTrackers.current.isStencilVisible !== true ||
        stateTrackers.current.activeStencil !== activeStencilKey
      ) {
        stateTrackers.current.isStencilVisible = true;
        stateTrackers.current.activeStencil = activeStencilKey;
        updateStencilDOM(
          activeStencilKey,
          true,
          stateTrackers.current.stencilColor,
        );
      }

      if (hold && hold2 && stateTrackers.current.stencilColor !== "#fff") {
        stateTrackers.current.stencilColor = "#fff";
        updateStencilDOM(activeStencilKey, true, "#fff");
      }

      const containerWidth = window.innerWidth;
      const containerHeight = window.innerHeight;
      const videoAspect = videoRef.current
        ? videoRef.current.videoWidth / videoRef.current.videoHeight || 1
        : 1;
      const containerAspect = containerWidth / containerHeight;
      let displayWidth, displayHeight;
      if (videoAspect > containerAspect) {
        displayWidth = containerWidth;
        displayHeight = containerWidth / videoAspect;
      } else {
        displayHeight = containerHeight;
        displayWidth = containerHeight * videoAspect;
      }

      const isSideLikeRegion = [
        "Side-Left",
        "Side-Right",
        "Side-Left-Front",
        "Side-Left-Back",
        "Side-Right-Front",
        "Side-Right-Back",
      ].includes(currentRegion);
      let sWidth = displayWidth - 40;
      let sLeft = (containerWidth - displayWidth) / 2 + 20;
      let sHeight = isSideLikeRegion ? displayHeight - 45 : displayHeight - 40;
      let sTop = isSideLikeRegion
        ? (containerHeight - displayHeight) / 2 + 22.5
        : (containerHeight - displayHeight) / 2 + 20;

      // Congested sub-stencils render portrait with "xMidYMax meet" — centered
      // horizontally and anchored to the bottom of the video box. Build the fit-box
      // from the stencil's ACTUAL rendered rectangle in BOTH dimensions so
      // topLeft/bottomRight tightly bound the visible sub-stencil instead of the full
      // video box. Only affects the four sub-stencils; main stencils keep the box
      // above. NOTE: in the common (height-limited) case renderedH === displayHeight,
      // so the vertical box is unchanged; renderedW < displayWidth narrows the width.
      const subVb = subStencilViewBox[currentRegion];
      if (subVb) {
        const [vbW, vbH] = subVb;
        const scale = Math.min(displayWidth / vbW, displayHeight / vbH);
        const renderedW = vbW * scale;
        const renderedH = vbH * scale;
        sWidth = renderedW - 40;
        sLeft =
          (containerWidth - renderedW) / 2 +
          20 +
          renderedW * (subStencilShiftX[currentRegion] || 0);
        sHeight = renderedH - 45;
        // Bottom-anchored: the stencil's bottom edge sits at the bottom of the
        // video display box, so its top is offset by the letterbox gap above it.
        sTop =
          (containerHeight - displayHeight) / 2 +
          (displayHeight - renderedH) +
          22.5;
      }

      const xOffset = (containerWidth - displayWidth) / 2;
      const yOffset = (containerHeight - displayHeight) / 2;
      const scaleX = frameResolution / displayWidth;
      const scaleY = frameResolution / displayHeight;
      const topLeft = [(sLeft - xOffset) * scaleX, (sTop - yOffset) * scaleY];
      const bottomRight = [
        (sLeft + sWidth - xOffset) * scaleX,
        (sTop + sHeight - yOffset) * scaleY,
      ];

      if (currentRegion === activeStencilKey) {
        rightArrowVin.current.style.display = "none";
        leftArrowVin.current.style.display = "none";
        if (
          (stencilCheckInterval === undefined ||
            stencilCheckInterval === null) &&
          hold
        ) {
          stencilCheckInterval = setTimeout(() => {
            if (chooseRegionStencil.current.style.display !== "flex" && !hold) {
              clearInterval(imageFrameInterval);
              hold = false;

              stateTrackers.current.activeStencil = null;
              stateTrackers.current.isStencilVisible = false;
              updateStencilDOM(null, false, "#fff");

              hideAllArrows();
              displayText.current.innerHTML = "";
              displayText.current.style.display = "none";
              holdImage.current.style.display = "none";
              skipDiv.current.style.display = "flex";
            }
          }, 17000);
        }

        let value = goodFrame(
          topLeft,
          bottomRight,
          detections,
          currentRegion,
          currentAngle,
          frameResolution,
          subStencil,
        );
        if (detectionBox.current) {
          detectionBox.current.innerHTML = "";
        }

        // detections.forEach((det) => {
        //   const [x, y, w, h] = det.bbox;
        //   drawBoxWithDiv(
        //     [x * frameResolution, y * frameResolution],
        //     [x * frameResolution + w * frameResolution, y * frameResolution + h * frameResolution],
        //     "blue",
        //   );
        // });
        // drawBoxWithDiv(value["maskMin"], value["maskMax"], "green");
        // partDataValue.current.innerHTML = JSON.stringify({
        //   ...value["part_list"],
        // });

        if (hold) {
          if (hold2 && value["partialDetection"] === true) {
            // Claimed straight away either way, so the detect loop cannot come
            // back through here while the shots are being taken.
            hold2 = false;

            // In congested mode the blue verdict belongs to the sub-stencil,
            // not the parent: the parent's dial colour is decided only once
            // BOTH subs have ended, in finalizeCongestedDial. Outside congested
            // mode the dial goes blue here as it always did.
            const crBlue = congestedRef.current;
            const isCongestedSub =
              crBlue.active && currentStencil === crBlue.parentRegion;
            const subIdxAtCapture = isCongestedSub ? crBlue.currentIdx : -1;
            const markBlue = (region) => {
              if (!isCongestedSub) {
                captureStencilDialRed = [...captureStencilDialRed, region];
              } else if (crBlue.results[subIdxAtCapture] !== "green") {
                crBlue.results[subIdxAtCapture] = "blue";
              }
            };

            if (isBlurMode()) {
              // Partial detection is the trigger, not the verdict. The stencil
              // is held white until two sharp shots are actually in hand, so
              // blue never means "a blur was photographed here".
              const stencilAtCapture = currentStencil;
              const regionAtCapture = currentRegion;
              // The sub-stencil is what is on screen in congested mode, so it,
              // not the parent, is the key the colour has to be applied to.
              const keyAtCapture = activeStencilKey;
              if (holdImage.current) holdImage.current.style.display = "flex";
              runStencilShots(() =>
                collectBestShots(
                  STENCIL_SHOTS,
                  regionAtCapture,
                  detections,
                  // The green transition sets hold = false as it starts, and it
                  // is the more important of the two: once it has taken over
                  // there is no point still shooting for blue.
                  () => !hold,
                ),
              ).then((shots) => {
                // The green path shows this same image and owns it from the
                // moment it starts, so leave it alone if it has taken over.
                if (hold && holdImage.current)
                  holdImage.current.style.display = "none";
                // The collection outlived its stencil -- the user skipped the
                // region, or picked another one, while it was still shooting.
                // The old burst was killed by skipButton's clearInterval; this
                // has to stand down for itself, or it uploads shots of one
                // region under the tag of the next and drives the wrong
                // stencil's colour.
                if (currentStencil !== stencilAtCapture) return;
                // Same stand-down for congested mode, which the check above
                // cannot see: both subs run under the one parent region, and
                // congestedRef.current is replaced wholesale when the mode is
                // answered or restarted, so a surviving object with the same
                // index is the only case where these shots still describe the
                // sub that is on screen now.
                if (
                  isCongestedSub &&
                  (congestedRef.current !== crBlue ||
                    crBlue.currentIdx !== subIdxAtCapture)
                )
                  return;
                if (!shots.length) {
                  // Nothing usable and the collection was cut short. Leave the
                  // stencil white rather than colouring it on no evidence.
                  return;
                }
                shots.forEach((shot) => uploadImg(shot));
                markBlue(regionAtCapture);
                stateTrackers.current.stencilColor = "#02CCFE";
                updateStencilDOM(keyAtCapture, true, "#02CCFE");
              })
                .catch(() => {
                  // Release the claim taken above, so a later frame can try for
                  // blue again rather than the stencil sitting white forever.
                  hold2 = true;
                });
            } else {
              stateTrackers.current.stencilColor = "#02CCFE";
              updateStencilDOM(activeStencilKey, true, "#02CCFE");

              markBlue(currentRegion);
              imageFrameInterval = setInterval(() => {
                let b = captureImgFrame(true);
                if (b) {
                  uploadImg(b);
                }
              }, 300);
              setTimeout(() => {
                clearInterval(imageFrameInterval);
              }, 1000);
            }
          }
          if (value["flagValue"] === 0) {
            setHoldSkip(false);
            clearTimeout(InstructionClear);
            checkImageList = [];
            hold = false;
            checkLumaValue = true;
            clearTimeout(stencilCheckInterval);
            stencilCheckInterval = null;
            hideAllArrows();
            displayText.current.style.display = "flex";
            displayText.current.innerHTML = Object.keys(
              config["video-page"],
            ).includes("Hold this position for 3 seconds.")
              ? config["video-page"]["Hold this position for 3 seconds."]
              : getTranslateText("Hold this position for 3 seconds.");
            holdImage.current.style.display = "flex";

            // Everything that happens once the shots for this stencil are in:
            // the green, and the advance to the next region. Held in one place
            // so the gated and ungated paths below reach it identically.
            const finishStencilGreen = () => {
              displayText.current.innerHTML = "";
              displayText.current.style.display = "none";
              frameUploadStencil = true;
              holdImage.current.style.display = "none";

              const cr = congestedRef.current;
              // currentStencil holds the parent region during congested mode
              // (currentRegion is the sub-key), and equals currentRegion in
              // normal mode — so it's the reliable identity for the dial.
              const isCongested =
                cr.active && currentStencil === cr.parentRegion;

              // For non-congested regions, mark the arc green now.
              // For congested regions, defer the parent's arc color to the
              // finalize step (green ONLY if both subs are green, else blue).
              if (!isCongested) {
                captureStencilDialGrren = [
                  ...captureStencilDialGrren,
                  currentStencil,
                ];
              }

              stateTrackers.current.stencilColor = "#90EE90";
              const greenKey = isCongested
                ? cr.keys[cr.currentIdx]
                : currentStencil;
              updateStencilDOM(greenKey, true, "#90EE90");

              setTimeout(() => {
                setHoldSkip(true);
              }, 500);
              setTimeout(() => {
                frameUploadStencil = false;

                if (isCongested) {
                  cr.results[cr.currentIdx] = "green";
                  if (cr.currentIdx === 0) {
                    // First sub captured — switch to second sub, don't advance yet
                    cr.currentIdx = 1;
                    updateStencilDOM(cr.keys[1], true, "#fff");
                    detectionBox.current.style.display = "none";
                    hold = true;
                    hold2 = true;
                    stencilImageDivRunOnce = true;
                    stateTrackers.current.stencilColor = "#fff";
                  } else {
                    // Second sub captured — both subs decided, set the dial color
                    // now (green only if both green, blue if any activity, else grey).
                    cr.active = false;
                    finalizeCongestedDial(currentStencil, cr.results);
                    advanceCapturedRegion(currentStencil);
                    detectionBox.current.style.display = "none";
                    hold = true;
                    hold2 = true;
                    stencilImageDivRunOnce = true;
                    stateTrackers.current.stencilColor = "#fff";
                    updateStencilDOM(currentStencil, true, "#fff");
                  }
                } else {
                  // Normal (non-congested) capture advance
                  advanceCapturedRegion(currentRegion);
                  detectionBox.current.style.display = "none";
                  hold = true;
                  hold2 = true;
                  stencilImageDivRunOnce = true;
                  stateTrackers.current.stencilColor = "#fff";
                  updateStencilDOM(currentStencil, true, "#fff");
                }
              }, 1000);
            };

            const regionAtCapture = currentRegion;
            const stencilAtCapture = currentStencil;
            if (isBlurMode()) {
              // Same one-second settle as before, then two shots half a second
              // apart, each proved sharp. The hold image put up above stays up
              // for the whole collection -- finishStencilGreen takes it down --
              // so the user is asked to hold until the shots are actually good,
              // not for a fixed two seconds regardless.
              setTimeout(() => {
                runStencilShots(() =>
                  collectBestShots(STENCIL_SHOTS, regionAtCapture, detections),
                )
                  .then((shots) => {
                    // Stood down: the flow left this stencil while the shots
                    // were being taken. Whatever moved it on (skipButton, the
                    // region chooser) has already restored hold and advanced,
                    // so finishing here would advance a second time and mark
                    // the wrong region green. Only the hold image is ours to
                    // clear -- finishStencilGreen is what normally takes it
                    // down, and it is not going to run.
                    if (currentStencil !== stencilAtCapture) {
                      if (holdImage.current)
                        holdImage.current.style.display = "none";
                      return false;
                    }
                    shots.forEach((shot) => uploadImg(shot));
                    return true;
                  })
                  // Whatever happens to the shots, the stencil has to finish.
                  // hold is false from here until finishStencilGreen puts it
                  // back, so a rejection that skipped it would strand the user
                  // on a stencil that can never complete -- unless the flow has
                  // already left this stencil, which is the one case where
                  // finishing is the wrong answer.
                  .catch(() => currentStencil === stencilAtCapture)
                  .then((finish) => {
                    if (finish) finishStencilGreen();
                  });
              }, 1000);
            } else {
              setTimeout(() => {
                imageFrameInterval = setInterval(() => {
                  let b = captureImgFrame(true);
                  if (b) {
                    uploadImg(b);
                  }
                }, 300);
              }, 1000);
              setTimeout(() => {
                clearInterval(imageFrameInterval);
                finishStencilGreen();
              }, 2000);
            }
          }
          if (value["flagValue"] === 5) {
            checkImageList3.push(value["flagValue"]);
            checkImageList2 = [];
          }
          if (value["flagValue"] === 1 || value["flagValue"] === 2) {
            checkImageList.push(value["flagValue"]);
            checkImageList3 = [];
            checkImageList2 = [];
          }
          if (value["flagValue"] === -1) {
            checkImageList2.push(value["flagValue"]);
          }
          // partDataValueList.current.innerHTML = `Flag 1&2: ${checkImageList}<br>
          //   Flag 5: ${checkImageList3}<br>
          //   Flag -1: ${checkImageList2}<br>
          //   `;
          if (checkImageList.length > detectionFuncTime) {
            value["flagValue"] = getMaxItem(checkImageList);
            // partDataValueList.current.innerHTML =
            //   partDataValueList.current.innerHTML +
            //   `<br>final flag: ${value["flagValue"]}`;
            if (value["flagValue"] === 1) {
              clearTimeout(InstructionClear);
              upArrow.current.style.display = "none";
              downArrow.current.style.display = "none";
              leftNearArrow.current.style.display = "none";
              rightNearArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "flex";
              rightFarArrow.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move away from the car")
                ? config["video-page"]["Move away from the car"]
                : getTranslateText("Move away from the car");
            } else if (value["flagValue"] === 2) {
              clearTimeout(InstructionClear);
              upArrow.current.style.display = "none";
              downArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "none";
              rightFarArrow.current.style.display = "none";
              leftNearArrow.current.style.display = "flex";
              rightNearArrow.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move towards the car")
                ? config["video-page"]["Move towards the car"]
                : getTranslateText("Move towards the car");
            } else if (value["flagValue"] === 3) {
              clearTimeout(InstructionClear);
              leftNearArrow.current.style.display = "none";
              rightNearArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "none";
              rightFarArrow.current.style.display = "none";
              downArrow.current.style.display = "none";
              upArrow.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move Up")
                ? config["video-page"]["Move Up"]
                : getTranslateText("Move Up");
            } else if (value["flagValue"] === 4) {
              clearTimeout(InstructionClear);
              leftNearArrow.current.style.display = "none";
              rightNearArrow.current.style.display = "none";
              leftFarArrow.current.style.display = "none";
              rightFarArrow.current.style.display = "none";
              upArrow.current.style.display = "none";
              downArrow.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move Down")
                ? config["video-page"]["Move Down"]
                : getTranslateText("Move Down");
            }
            if ([1, 2, 3, 4].includes(value["flagValue"])) {
              InstructionClear = setTimeout(() => {
                hideAllArrows();
                displayText.current.style.display = "flex";
                displayText.current.innerHTML = "";
              }, 3000);
            }
            checkImageList = [];
          }
          if (checkImageList3.length === 4) {
            clearTimeout(InstructionClear);
            checkImageList = [];
            leftNearArrow.current.style.display = "none";
            rightNearArrow.current.style.display = "none";
            leftFarArrow.current.style.display = "none";
            rightFarArrow.current.style.display = "none";
            upArrow.current.style.display = "none";
            downArrow.current.style.display = "none";
            displayText.current.style.display = "flex";
            displayText.current.innerHTML = Object.keys(
              config["video-page"],
            ).includes("Please adjust your camera to align with the stencils")
              ? config["video-page"][
              "Please adjust your camera to align with the stencils"
              ]
              : getTranslateText(
                "Please adjust your camera to align with the stencils",
              );
            checkImageList3 = [];
          }
          if (checkImageList2.length === 5) {
            clearTimeout(InstructionClear);
            checkImageList = [];
            hideAllArrows();
            displayText.current.style.display = "flex";
            displayText.current.innerHTML = Object.keys(
              config["video-page"],
            ).includes(
              "You're too close or too far — Fit the car edges to the stencil outline",
            )
              ? config["video-page"][
              "You're too close or too far — Fit the car edges to the stencil outline"
              ]
              : getTranslateText(
                "You're too close or too far — Fit the car edges to the stencil outline",
              );
            checkImageList2 = [];
          }
        }
      } else {
        if (stateTrackers.current.isStencilVisible === true) {
          hideAllArrows();
          let position = calculateUserPositions(
            currentRegion,
            activeStencilKey,
          );
          switch (position) {
            case "right":
              rightArrowVin.current.style.display = "none";
              leftArrowVin.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move Left")
                ? config["video-page"]["Move Left"]
                : getTranslateText("Move Left");
              break;
            case "left":
              leftArrowVin.current.style.display = "none";
              rightArrowVin.current.style.display = "flex";
              displayText.current.style.display = "flex";
              displayText.current.innerHTML = Object.keys(
                config["video-page"],
              ).includes("Move Right")
                ? config["video-page"]["Move Right"]
                : getTranslateText("Move Right");
              break;
            case "same":
              leftArrowVin.current.style.display = "none";
              rightArrowVin.current.style.display = "none";
              break;
            default:
              leftArrowVin.current.style.display = "none";
              rightArrowVin.current.style.display = "none";
              displayText.current.style.display = "none";
              break;
          }
        }
      }
    } else {
      stateTrackers.current.isStencilVisible = false;
      stateTrackers.current.activeStencil = null;
      updateStencilDOM(null, false, "#fff");

      if (upArrow.current) upArrow.current.style.display = "none";
      if (downArrow.current) downArrow.current.style.display = "none";
      if (leftFarArrow.current) leftFarArrow.current.style.display = "none";
      if (rightFarArrow.current) rightFarArrow.current.style.display = "none";
      if (leftNearArrow.current) leftNearArrow.current.style.display = "none";
      if (rightNearArrow.current) rightNearArrow.current.style.display = "none";
      if (leftArrowVin.current) leftArrowVin.current.style.display = "none";
      if (rightArrowVin.current) rightArrowVin.current.style.display = "none";
      if (displayText.current) {
        displayText.current.style.display = "none";
        displayText.current.innerHTML = "";
      }
    }
  };

  const filterByLargerBbox = (detections) => {
    const bestDetections = {};
    const keepAll = ["wheel", "window_glass", "headlight", "taillight"];
    detections.forEach((det) => {
      const label = det.label;
      const [x, y, w, h] = det.bbox;
      const area = w * h;
      if (keepAll.includes(label)) {
        if (!(label in bestDetections)) {
          bestDetections[label] = [];
        }
        bestDetections[label].push({ area, det });
      } else {
        if (!(label in bestDetections)) {
          bestDetections[label] = { area, det };
        } else {
          if (area > bestDetections[label].area) {
            bestDetections[label] = { area, det };
          }
        }
      }
    });
    return Object.values(bestDetections).flatMap((entry) =>
      Array.isArray(entry) ? entry.map((e) => e.det) : entry.det,
    );
  };

  const isImageSharp = (base64) => {
    uploadImgInterim(base64);
  };

  const detectFrame = async (video, model) => {
    if (!active || !videoRef.current) return;
    // Rate-cap the loop (see minDetectIntervalMs above). Skipped iterations
    // just reschedule; the timestamp check is ~free.
    const nowTs = Date.now();
    if (nowTs - lastDetectIterationTs < minDetectIntervalMs) {
      if (active && videoRef.current)
        requestAnimationFrame(() => detectFrame(video, model));
      return;
    }
    lastDetectIterationTs = nowTs;
    if (Object.values(data.regionsCovered).every((val) => val !== 0)) {
      setAllSideCoveredVideo(true);
    }

    let newImgURL = captureImgFrame(false);

    await tf.nextFrame();

    if (newImgURL) {
      if (getTimeonce) {
        getTimeonce = false;
        startTimeModel = performance.now();
      }
      let detections = [];
      // Off-main-thread inference when available (same recipe as NewVideo):
      // the worker runs the same model on the same 128x128 input (accuracy
      // unchanged); if it isn't ready or has died, the original main-thread
      // path below runs instead.
      const inferenceWorker = !(
        Object.keys(config).includes("int8Model") && config["int8Model"]
      )
        ? getSharedInferenceWorker("car")
        : null;
      const useWorker = !!(
        inferenceWorker &&
        inferenceWorker.ready &&
        inferenceWorker.isAlive()
      );
      // Worker path keeps all tensors inside the worker -> no engine scope.
      !useWorker &&
        !Object.keys(config).includes("int8Model") &&
        tf.engine().startScope();
      if (detectMlCheck) {
        detectMlCheck = false;
        patLogs("part_detection_is_working", inspectionId);
      }
      try {
        const inferStart = performance.now();
        // Inference timing: from the raw frame going in to detections coming out.
        // const inferStart = performance.now(); // DEBUG (commented out)
        let processedFrame;
        if (useWorker) {
          // One transferred ImageBitmap in; plain detections + the low-light
          // channel means out (no tensors cross the boundary).
          const res = await inferenceWorker.detect(video);
          if (!active || !videoRef.current) return;
          detections = res.detections;
          processedFrame = makeLowLightFrameShim(res.rgbMeans);
        } else {
          const ctx = resizeCtxRef.current;
          const canvas = resizeCanvasRef.current;
          if (!ctx || !canvas) return;

          ctx.drawImage(video, 0, 0, 320, 320);

          processedFrame =
            Object.keys(config).includes("int8Model") && config["int8Model"]
              ? preprocessVideo(canvas)
              : partDetector.processInput(video);

          await tf.nextFrame();

          const predictions =
            Object.keys(config).includes("int8Model") && config["int8Model"]
              ? ""
              : await model.executeAsync(processedFrame);

          if (!active || !videoRef.current) {
            if (processedFrame && !processedFrame.isDisposedInternal) {
              processedFrame.dispose();
            }
            if (!Object.keys(config).includes("int8Model")) {
              tf.engine().endScope();
            }
            return;
          }

          await tf.nextFrame();

          detections =
            Object.keys(config).includes("int8Model") && config["int8Model"]
              ? await runCarPartDetection(model, processedFrame)
              : partDetector.getDetectionObjects(predictions);
        }

        recordInference(performance.now() - inferStart, detections.length);
        /* ---- DEBUG LOGS (commented out) ----
        const inferMs = performance.now() - inferStart;
        console.log(
          `[inference] frame→detections: ${inferMs.toFixed(2)} ms — ${detections.length} detections`,
        );
        if (inferenceTimeRef.current) {
          inferenceTimeRef.current.innerHTML = `${inferMs.toFixed(1)} ms · ${detections.length} det`;
        }
        // Live detections log: show each detection's class id, label and score
        // exactly as the int8 model (runCarPartDetection) produced them.
        if (detectionLogRef.current) {
          const detLog = (detections || [])
            .map(
              (d) =>
                `${d.class !== undefined ? "#" + d.class + " " : ""}${d.label}` +
                `${d.score !== undefined ? " " + Number(d.score).toFixed(2) : ""}`,
            )
            .join("<br/>");
          detectionLogRef.current.innerHTML =
            `<b>Detections (${detections.length}):</b><br/>${detLog || "-"}`;
        }
        // Van / non_van flag: these classes are filtered out of detections in
        // NewPartDetector (used only to pick the threshold set), so read the
        // exposed classification directly to show what the model is seeing.
        if (vanFlagRef.current) {
          const vi = getLastVanInfo();
          vanFlagRef.current.style.background =
            vi.result === "van"
              ? "rgba(0, 150, 0, 0.85)"
              : vi.result === "non_van"
                ? "rgba(180, 0, 0, 0.85)"
                : "rgba(0, 0, 0, 0.6)";
          vanFlagRef.current.innerHTML =
            `van ${vi.van ? vi.van.toFixed(2) : "-"} | ` +
            `non_van ${vi.nonVan ? vi.nonVan.toFixed(2) : "-"} → ` +
            `<b>${vi.result.toUpperCase()}</b>`;
        }
        // Cold start: time from the first detection-loop frame (startTimeModel)
        // to the first frame that actually produces a detection.
        if (coldStartOnce && detections.length > 0) {
          coldStartOnce = false;
          if (coldStartTimeRef.current) {
            coldStartTimeRef.current.innerHTML = `cold: ${(
              performance.now() - startTimeModel
            ).toFixed(1)} ms`;
          }
        }
        ---- end DEBUG LOGS ---- */

        const filteredDetections = filterByLargerBbox(detections);

        // Continuous low-light check -> flash control. Throttled inside the
        // controller and deliberately not awaited, so the detection loop is
        // never blocked waiting on it.
        checkFrameForTorch(
          newImgURL,
          detections,
          videoRef.current ? videoRef.current.videoWidth : 0,
          videoRef.current ? videoRef.current.videoHeight : 0,
          guidance?.currentRegion,
        );
        // Dirty-lens popup. This module only judges frames at the moment it
        // keeps them, which is far too rarely to fill a ten second window, so
        // every frame is sampled here for the window alone -- it never decides
        // an upload, and leaves the verdict collectBestShots reads untouched.
        // Only the first ten seconds are judged; after that both calls return
        // straight away. Not awaited, like the torch. On for config["blurred"]
        // and for config["blurredNotification"] alone.
        sampleFrameForBlurWindow(
          newImgURL,
          detections,
          videoRef.current ? videoRef.current.videoWidth : 0,
          videoRef.current ? videoRef.current.videoHeight : 0,
        );
        if (takeBlurWindow()) {
          patLogs("blur popup shown - clean lens", inspectionId);
          setLensDirty(true);
        }
        // Only pass a sub-stencil key (one of the four congested halves) here;
        // for any normal region pass "" instead.
        const subStencilKeys = [
          "Side-Left-Back",
          "Side-Left-Front",
          "Side-Right-Back",
          "Side-Right-Front",
        ];
        const activeSubStencil =
          congestedRef.current.active &&
          subStencilKeys.includes(
            congestedRef.current.keys[congestedRef.current.currentIdx],
          )
            ? congestedRef.current.keys[congestedRef.current.currentIdx]
            : "";

        let [
          currentAngle,
          currentRegion,
          regionsCoveredMap,
          feedbacks,
          videoFreezeStatus,
          currentNudge,
          imgURL,
          allowImgURL,
          frameCountPerRegion,
          revolutionRegionCurrent,
          realGyroAngle,
          angleRF,
        ] = guidance.performChecksAndGetWarningMessage(
          filteredDetections,
          processedFrame,
          newImgURL,
          activeSubStencil,
        );
        const endTimeModel = performance.now();

        recordAngle(guidance, angleRF, realGyroAngle);
        recordDial(regionsCoveredMap, currentRegion);

        if (processedFrame && !processedFrame.isDisposedInternal) {
          processedFrame.dispose();
        }

        data = {
          text: feedbacks[feedbacks.length - 1],
          feedbacks: feedbacks,
          regionsCovered: regionsCoveredMap,
          angle: currentAngle !== -1 ? currentAngle : data.angle,
          region: currentRegion,
          nudges: currentNudge,
        };
        // partData.current.innerHTML = JSON.stringify({
        //   "rf Angle": angleRF,
        //   "normal gyro angle": realGyroAngle,
        //   "new logic gyro angle": data.angle,
        // });

        if (Object.values(regionsCoveredMap).some((value) => value > 0)) {
          if (staticRegion === "") {
            displayText.current.style.display = "none";
            displayText.current.innerHTML = "";
            staticRegion = currentRegion;
            setmainRegion(staticRegion);
          }
          updateStencilValue(
            currentRegion,
            detections,
            realGyroAngle,
            currentAngle,
            activeSubStencil,
          );

          instImage.current.style.display = "none";
          if (previousAngle.includes(currentAngle)) {
            previousAngle = previousAngle.filter(
              (item) => item !== currentAngle,
            );
            const now = performance.now();
            if (now - lastSharpCheck > 500) {
              let c = captureImgFrame(true);
              if (c) {
                isImageSharp(c);
              }
              lastSharpCheck = now;
            }
          }
        }
        captureStencilDialGrren.map((e) => {
          if (captureStencilDialRed.includes(e)) {
            captureStencilDialRed = captureStencilDialRed.filter(
              (item) => item !== e,
            );
          }
          if (Object.keys(showCoveredRegion).includes(e)) {
            showCoveredRegion[e] = 2;
          }
        });
        captureStencilDialRed.map((e) => {
          if (Object.keys(showCoveredRegion).includes(e)) {
            showCoveredRegion[e] = 1;
          }
        });
        // console.log(canvas1.current, data.angle, showCoveredRegion, clientId)
        drawArc(canvas1.current, data.angle, showCoveredRegion, clientId);

        allRegionsCovered = guidance.checkIfAllRegionsCovered();

        finalRegionsMap = showCoveredRegion;
        allowImgURLmain = allowImgURL;
        regionWiseData = frameCountPerRegion;
        actualGuidanceRegion = guidance.actualPartsCoveredMap;
        Object.keys(actualGuidanceRegion).map((e) => {
          allActualRegionDataLog.key = e;
          let takeOutValue = [];
          actualGuidanceRegion[e].forEach((i) => {
            takeOutValue.push(i);
          });
          allActualRegionDataLog[e] = takeOutValue;
        });
        if (!angleDetectedGyro.includes(currentAngle)) {
          angleDetectedGyro.push(currentAngle !== -1 ? currentAngle : 0);
        }
        if (
          JSON.stringify(showCoveredRegion) !==
          JSON.stringify(showCoveredRegioncheck)
        ) {
          sendCoveredArea(
            allGreen,
            showCoveredRegion,
            clientId,
            caseId,
            inspectionId,
          );
          showCoveredRegioncheck = showCoveredRegion;
        }
        if (
          JSON.stringify(allActualRegionDataLog) !==
          JSON.stringify(allActualRegionDataLogsCheck)
        ) {
          allActualRegionDataLog["VideoTimer"] = `${minutes} : ${seconds}`;
          allActualRegionDataLog["angleDetected"] = angleDetectedGyro;
          allActualRegionDataLog["DialStatus"] = showCoveredRegion;
          userLogs({
            position: 3,
            video_data: JSON.stringify(allActualRegionDataLog),
            inspectionId,
          });
          allActualRegionDataLogsCheck = allActualRegionDataLog;
        }

        if (consoleOnceModel && Object.keys(config).includes("int8Model")) {
          consoleOnceModel = false;
          coldStartText = `<br> Cold start: ${(endTimeModel - startTimeModel).toFixed(2)} ms`;
        }

        if (
          detectOnce &&
          Object.values(regionsCoveredMap).some((value) => value > 0) &&
          Object.keys(config).includes("int8Model")
        ) {
          detectOnce = false;
          regionDetectedText = `<br> Region detected: ${(endTimeModel - startTimeModel).toFixed(2)} ms`;
        }
      } catch (err) {
        // console.log("Error during detection:", err);
        let backendErrorPatterns = [
          /gl.*lost/i,
          /webgl.*context/i,
          /compile.*shader/i,
          /link.*shader/i,
          /link.*program/i,
          /vertex.*shader/i,
          /fragment.*shader/i,
          /failed.*shader/i,
          /webgl.*error/i,
          /webgpu/i,
          /device.*lost/i,
          /cannot.*create.*gpu/i,
          /gpu.*error/i,
          /wasm.*memory.*error/i,
          /memory.*access/i,
          /invalid.*memory/i,
          /cpu.*execution.*failed/i,
          /backend.*error/i,
          /backend.*failure/i,
          /tensor.*backend.*error/i,
          /unexpected.*backend/i,
        ];
        if (backendErrorPatterns.some((regex) => regex.test(err.message))) {
          const fallbackBackend =
            tf.engine().backendName === "webgl" ? "webgpu" : "cpu";
          await setBackendExternally(fallbackBackend);
        }
        if (
          getRedirectVideoToImgFlag() &&
          !backendErrorPatterns.some((regex) => regex.test(err.message))
        ) {
          patLogs(
            `Error from detect Frame ${err.message} ,${err.stack}`,
            inspectionId,
          );
          setErrorType(true);
          skipDivFallback.current.style.display = "flex";
        }
      } finally {
        !useWorker &&
          !Object.keys(config).includes("int8Model") &&
          tf.engine().endScope();
      }
    }

    if (active && videoRef.current) {
      requestAnimationFrame(() => detectFrame(video, model));
    }
  };

  const checklandScape = () => {
    startRefCheck = setInterval(() => {
      if (!isLandscape()) {
        if (warnRef.current) warnRef.current.style.display = "flex";
        if (startRef.current) startRef.current.style.display = "none";
      } else {
        if (warnRef.current) warnRef.current.style.display = "none";
        if (startRef.current) startRef.current.style.display = "flex";
      }
    }, 200);
  };
  const updateUI = () => {
    if (warnRef.current) {
      warnRef.current.style.display = isLandscape() ? "none" : "flex";
    }
    if (seconds >= 60) {
      minutes++;
      seconds = 0;
    }
    const videoLabel =
      config["video-page"]["Video"] || getTranslateText("Video");
    const secLabel = config["video-page"]["sec"] || getTranslateText("sec");
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
    if (timerRef.current) {
      timerRef.current.innerText = `${videoLabel} ${formattedMinutes}:${formattedSeconds} ${secLabel}`;
    }
  };

  const startCameraLocal = () => {
    leftArrowVin.current.style.display = "none";
    rightArrowVin.current.style.display = "none";
    detectionBox.current.style.display = "none";
    holdImage.current.style.display = "none";
    displayText.current.style.display = "none";
    stencilImageDiv.current.style.display = "none";
    chooseRegionStencil.current.style.display = "none";
    upArrow.current.style.display = "none";
    downArrow.current.style.display = "none";
    document.getElementById("window-arc2").style.visibility = "hidden";
    cardRef.current.style.display = "none";
    warnRef.current.style.display = "none";
    imgRef.current.style.display = "block";
    loaderGuidanceText.current.innerHTML = config["video-page"]["loadingText"];
    drawArc(canvas1.current, data.angle, data.regionsCovered, clientId);
    webCamPromise = navigator.mediaDevices
      .getUserMedia(getConstraint(config, clientId))
      .then((stream) => {
        window.stream = stream;
        track = stream.getTracks()[0];
        // Fresh track for the flash controller, and clear anything left
        // over from a previous session.
        resetTorch();
        setTorchTrack(
          track,
          inspectionId,
          Object.keys(config).includes("torch") && config["torch"],
        );
        // Same for blur gating. Everything captured in here is car capture --
        // there is no VIN or odometer step in this module -- so the switch goes
        // on with the camera and stays on for the session.
        resetBlur();
        setBlurFromConfig(config);
        videoRef.current.srcObject = stream;
        startVideoPlayback(videoRef.current, config);
        // camera started -> start recording (only if config.recordVideo === true)
        startCarVideoRecording({
          config,
          clientId,
          videoEl: videoRef.current,
          inspectionId,
          token,
          isIos,
        });
        document.getElementById("window-arc2").style.visibility = "visible";
        return new Promise(
          (resolve, _) => (videoRef.current.onloadedmetadata = () => resolve()),
        );
      })
      .catch((err) => {
        // console.error(err);
      });
  };

  const checkForRedirect = () => {
    if (getRedirectVideoToImgFlag()) {
      setTimeout(() => {
        let b = angleDetectedGyro.filter((num) => num !== 0);
        if (
          errorType !== true &&
          Object.values(data.regionsCovered).every((val) => val === 0)
        ) {
          if (
            Object.values(finalRegionsMap).filter(
              (value) => value === 1 || value === 2,
            ).length <= 0
          ) {
            setErrorType(false);
            skipDivFallback.current.style.display = "flex";
            patLogs("No detection happen", inspectionId);
          }
        } else if (
          errorType !== true &&
          Object.values(data.regionsCovered).some(
            (val) => val === 1 || val === 2,
          ) &&
          b.length < 5
        ) {
          patLogs(
            "detection happen but gyro value is not comming",
            inspectionId,
          );
          patLogs(`gyro values detected are: ${b}`, inspectionId);
          setErrorType(false);
          skipDivFallback.current.style.display = "flex";
        }
      }, 60000);
    }
  };

  const startRecording = () => {
    // checkForRedirect();
    displayText.current.style.display = "flex";
    instImage.current.style.display = "flex";
    displayText.current.innerHTML = Object.keys(config["video-page"]).includes(
      "Calculating angle. Please point the camera at the car.",
    )
      ? config["video-page"][
      "Calculating angle. Please point the camera at the car."
      ]
      : getTranslateText(
        "Calculating angle. Please point the camera at the car.",
      );
    patLogs("camera button clicked", inspectionId);
    cardRef.current.style.display = "flex";
    sendLogData({ position: 9, record_button: "yes", inspectionId });
    startRef.current.style.display = "none";
    // Warm the off-thread inference worker in parallel with the main-thread
    // model load; detectFrame switches to it once ready (and falls back to
    // the main-thread model seamlessly if it can't run on this browser).
    getSharedInferenceWorker("car");
    minDetectIntervalMs = Object.keys(config["video-page"]).includes(
      "detectIntervalMs",
    )
      ? config["video-page"]["detectIntervalMs"]
      : 250;
    logModelInitStart();
    // const modelInitStart = performance.now(); // DEBUG (commented out)
    Promise.all([getModel(), webCamPromise])
      .then((values) => {
        clearInterval(startRefCheck);
        sendLogData({ position: 6, model_initialized: "yes", inspectionId });
        if (Object.keys(config).includes("int8Model")) {
          model = values[0]["model"];
          logModelInitEnd(values[0]["time"]);
          showResult.current.innerHTML =
            showResult.current.innerHTML +
            ` <br> Loading time: ${values[0]["time"]} ms `;
          /* DEBUG LOG (commented out)
          if (modelInitTimeRef.current) {
            modelInitTimeRef.current.innerHTML = `init: ${Number(
              values[0]["time"],
            ).toFixed(1)} ms`;
          }
          */
        } else {
          model = values[0];
          logModelInitEnd();
          /* DEBUG LOG (commented out)
          if (modelInitTimeRef.current) {
            modelInitTimeRef.current.innerHTML = `init: ${(
              performance.now() - modelInitStart
            ).toFixed(1)} ms`;
          }
          */
        }
        detectFrame(videoRef.current, model);
        cardRef.current.style.display = "none";
        startTimer = setInterval(() => {
          seconds++;
          endTimer++;
          requestAnimationFrame(() => updateUI());
        }, 1000);
        setCurrentPage("Model initialize");
      })
      .catch((error) => {
        // console.log(error);
        if (getRedirectVideoToImgFlag()) {
          patLogs(`Model realted problem ${error.message}`, inspectionId);
          setErrorType(true);
          skipDivFallback.current.style.display = "flex";
        }
        sendLogData({
          position: 6,
          model_initialized: `no - ${error.message}`,
          inspectionId,
        });
        setCurrentPage("Model not initialize");
      });
  };

  const stopRecording = async (clicked, submitFlag) => {
    clearInterval(frameInterval);
    sendCoveredArea(allGreen, finalRegionsMap, clientId, caseId, inspectionId);
    if (!typeof actualGuidanceRegion === "undefined") {
      Object.keys(actualGuidanceRegion).map((e) => {
        allActualRegionData.key = e;
        let takeOutValue = [];
        actualGuidanceRegion[e].forEach((i) => {
          takeOutValue.push(i);
        });
        allActualRegionData[e] = takeOutValue;
      });
    }
    allActualRegionData["VideoTimer"] = `${minutes} : ${seconds}`;
    allActualRegionData["angleDetected"] = angleDetectedGyro;
    allActualRegionData["lowLightImage"] = WholeLightLumaData;
    allActualRegionData["DialStatus"] = finalRegionsMap;
    allActualRegionData["currentUploadedPartCount"] = currentUploadedPartCount;
    actualRegion(allActualRegionData, inspectionId);
    setImgCOunt(inspectionId, {
      regionWiseData,
      afterFrameimgValue,
      imgValue,
      ...allowImgURLmain,
      allActualRegionData,
    });
    stopRecordingML = true;
    patLogs("stop recording clicked", inspectionId);
    // camera stopping -> stop recording and upload the video
    stopCarVideoRecordingAndUpload();
    active = false;
    clearInterval(startTimer);
    window.stream = null;
    track.stop();
    delete allActualRegionData.lowLightImage;
    userLogs({
      position: 3,
      video_data: JSON.stringify(allActualRegionData),
      inspectionId,
    });
    handleNext();
  };

  const back = () => {
    logbugs = true;
    // camera closing -> stop recording and upload the video
    stopCarVideoRecordingAndUpload();
    window.stream = null;
    track.stop();
    patLogs("clicked back button", inspectionId);
    if (["opes_prod", "opes_uat"].includes(clientId)) {
      setScreen("menuOpes");
    } else {
      setScreen("menu");
    }
  };

  const handleNext = () => {
    logbugs = false;
    flushDial();
    patLogs("video module is completed", inspectionId);
    setTimeout(() => {
      if (currentBlock["mandatory"] && captured > 0) {
        let temp1 = mandatory;
        temp1[currentBlock["id"]] = "completed";
        setMandatory(temp1);
      }
      if (captured > 0) {
        let temp = condition;
        temp[currentBlock["id"]] = "completed";
        setCondition(temp);
        setLog(`${currentBlock["tag"]} was captured`);
        resumeFlowFinalSubmitHandler(currentBlock["id"]);
      }
      setPortoModuleComplete(currentBlock["tag"])
      if (["opes_prod", "opes_uat"].includes(clientId)) {
        setScreen("menuOpes");
      } else {
        if (Object.keys(config).includes("directModule")) {
          setScreen("success");
        } else {
          setScreen("menu");
        }
      }
    }, 1000);
  };

  const alignAllStencilAccordingUser = (e, position) => {
    const items = Object.keys(regionStencil);
    const index = items.indexOf(e);
    let res;
    if (index === -1) {
      res = [];
    } else if (position === "right") {
      res = [...items.slice(index), ...items.slice(0, index)];
    } else if (position === "left") {
      const left = items.slice(0, index + 1).reverse();
      const right = items.slice(index + 1).reverse();
      res = [...left, ...right];
    } else {
      res = [];
    }
    return res;
  };

  const missedCheckedStep = (e) => {
    missedstep = true;
    const nextStencil = [...skipStencil];
    setalignStencil(nextStencil);
    if (nextStencil.length > 0) {
      setmainRegion(nextStencil[0]);
      currentStencil = nextStencil[0];
      stateTrackers.current.stencilColor = "#fff";
      updateStencilDOM(currentStencil, true, "#fff");
    }
    setcapturedStencil((prev) =>
      prev.filter((item) => !skipStencil.includes(item)),
    );
    setSkipStencil([]);
    chooseRegionStencil.current.style.display = "none";
  };

  const checkStep = (e) => {
    hold = true;
    hold2 = true;
    if (e === "previous") {
      setalignStencil(
        alignAllStencilAccordingUser(
          Object.keys(regionStencil)[
          Object.keys(regionStencil).indexOf(mainRegion) === 0
            ? 7
            : Object.keys(regionStencil).indexOf(mainRegion) - 1
          ],
          "left",
        ),
      );
      setmainRegion(
        Object.keys(regionStencil)[
        Object.keys(regionStencil).indexOf(mainRegion) === 0
          ? 7
          : Object.keys(regionStencil).indexOf(mainRegion) - 1
        ],
      );
      currentStencil =
        Object.keys(regionStencil)[
        Object.keys(regionStencil).indexOf(mainRegion) === 0
          ? 7
          : Object.keys(regionStencil).indexOf(mainRegion) - 1
        ];
      chooseRegionStencil.current.style.display = "none";
    } else if (e === "after") {
      setalignStencil(
        alignAllStencilAccordingUser(
          Object.keys(regionStencil)[
          Object.keys(regionStencil).indexOf(mainRegion) === 7
            ? 0
            : Object.keys(regionStencil).indexOf(mainRegion) + 1
          ],
          "right",
        ),
      );
      setmainRegion(
        Object.keys(regionStencil)[
        Object.keys(regionStencil).indexOf(mainRegion) === 7
          ? 0
          : Object.keys(regionStencil).indexOf(mainRegion) + 1
        ],
      );
      currentStencil =
        Object.keys(regionStencil)[
        Object.keys(regionStencil).indexOf(mainRegion) === 7
          ? 0
          : Object.keys(regionStencil).indexOf(mainRegion) + 1
        ];
      stateTrackers.current.stencilColor = "#fff";
      updateStencilDOM(currentStencil, true, "#fff");
      chooseRegionStencil.current.style.display = "none";
    } else if (e === "next") {
      chooseRegionStencil.current.style.display = "none";
    }
  };

  useEffect(() => {
    if (!congestedEnabled) return;
    if (
      (mainRegion === "Side-Left" || mainRegion === "Side-Right") &&
      !congestedRef.current.active &&
      !capturedStencil.includes(mainRegion) &&
      congestedAreaDiv.current &&
      congestedAreaDiv.current.style.display !== "flex" &&
      congestedSubDiv.current?.style.display !== "flex"
    ) {
      if (firstSideVisited === null) {
        if (capturedStencil.length === 0) {
          firstSideVisited = mainRegion;
        } else {
          firstSideVisited = "none";
          patLogs("congested popup shown", inspectionId);
          congestedAreaDiv.current.style.display = "flex";
          updateStencilDOM(null, false, "#fff");
        }
      } else if (firstSideVisited !== mainRegion) {
        patLogs("congested popup shown", inspectionId);
        congestedAreaDiv.current.style.display = "flex";
        updateStencilDOM(null, false, "#fff");
      }
    }
  }, [mainRegion, capturedStencil, congestedEnabled]);

  useEffect(() => {
    // Module-level, so it survives an unmount. Without this reset a second
    // capture in the same tab starts with the previous run's value and the
    // congested prompt either never opens for one side or opens on both from
    // the first frame.
    firstSideVisited = null;
    instImage.current.style.display = "none";
    const canvas = document.createElement("canvas");
    canvas.width = 320;
    canvas.height = 320;
    resizeCanvasRef.current = canvas;
    resizeCtxRef.current = canvas.getContext("2d", {
      willReadFrequently: true,
    });
  }, []);

  useEffect(() => {
    checklandScape();
    setStopPing(null);
    startCameraLocal();

    const onResize = () => {
      lastLayoutRegion = null;
      lastLayoutWidth = 0;
      lastLayoutHeight = 0;
      if (currentStencil) setupVideoWithStencilBox(currentStencil);
    };
    window.addEventListener("resize", onResize);
    window.addEventListener("orientationchange", onResize);
    return () => {
      active = false;
      clearInterval(startTimer);
      clearInterval(imageFrameInterval);
      clearInterval(startRefCheck);
      if (track) {
        try {
          track.stop();
        } catch (e) {
          // console.log("Error stopping track in useEffect cleanup:", e);
        }
      }
      window.removeEventListener("resize", onResize);
      window.removeEventListener("orientationchange", onResize);
    };
  }, []);

  return (
    <div
      id="screen3"
      ref={screen3}
      style={{ position: "relative", height: "100dvh" }}
    >
      <TorchModeControl />
      {/* ---- DEBUG PANELS (commented out) ----
      <div
        ref={vanFlagRef}
        style={{
          position: "absolute",
          top: "8px",
          right: "8px",
          margin: 0,
          padding: "4px 8px",
          background: "rgba(0, 0, 0, 0.6)",
          color: "#fff",
          font: "12px/1.4 monospace",
          borderRadius: "4px",
          zIndex: 6,
          pointerEvents: "none",
        }}
      ></div>
      <div
        ref={detectionLogRef}
        style={{
          position: "absolute",
          top: "8px",
          left: "8px",
          maxWidth: "45vw",
          maxHeight: "60vh",
          overflowY: "auto",
          margin: 0,
          padding: "6px 8px",
          background: "rgba(0, 0, 0, 0.6)",
          color: "#fff",
          font: "11px/1.4 monospace",
          borderRadius: "4px",
          zIndex: 5,
          pointerEvents: "auto",
        }}
      ></div>
      <p
        ref={coldStartTimeRef}
        style={{
          position: "absolute",
          bottom: "60px",
          right: "8px",
          margin: 0,
          padding: "4px 8px",
          background: "rgba(0, 0, 0, 0.6)",
          color: "#ffab40",
          font: "12px/1.4 monospace",
          borderRadius: "4px",
          zIndex: 5,
          pointerEvents: "none",
        }}
      ></p>
      <p
        ref={modelInitTimeRef}
        style={{
          position: "absolute",
          bottom: "34px",
          right: "8px",
          margin: 0,
          padding: "4px 8px",
          background: "rgba(0, 0, 0, 0.6)",
          color: "#40c4ff",
          font: "12px/1.4 monospace",
          borderRadius: "4px",
          zIndex: 5,
          pointerEvents: "none",
        }}
      ></p>
      <p
        ref={inferenceTimeRef}
        style={{
          position: "absolute",
          bottom: "8px",
          right: "8px",
          margin: 0,
          padding: "4px 8px",
          background: "rgba(0, 0, 0, 0.6)",
          color: "#00e676",
          font: "12px/1.4 monospace",
          borderRadius: "4px",
          zIndex: 5,
          pointerEvents: "none",
        }}
      ></p>
      ---- end DEBUG PANELS ---- */}
      <p
        ref={showResult}
        style={{
          display: "none",
          position: "absolute",
          top: "0%",
          left: "0%",
          backgroundColor: "white",
          zIndex: 2,
        }}
      ></p>
      <img
        src={HoldSvg}
        ref={instImage}
        px
        style={{
          position: "absolute",
          top: "70%",
          left: "50%",
          zIndex: 2,
          height: "100px",
          width: "100px",
          transform: "translate(-50%, -70%)",
        }}
      />
      <canvas
        ref={canvasRef}
        id="ios-canvas"
        style={
          getAspectRatioClientList(clientId, config)
            ? {
              width: "100vw",
              height: "100vh",
              objectFit: "contain",
              backgroundColor: "black",
              position: "absolute",
              top: 0,
              left: 0,
            }
            : { position: "absolute", top: 0, left: 0 }
        }
      ></canvas>
      <video
        ref={videoRef}
        id="videoWindow"
        style={
          getAspectRatioClientList(clientId, config)
            ? {
              width: "100vw",
              height: "100vh",
              objectFit: "contain",
              backgroundColor: "black",
              position: "absolute",
              top: 0,
              left: 0,
            }
            : { position: "absolute", top: 0, left: 0 }
        }
        autoPlay
        playsInline
      ></video>
      <div className="video-instructions-stencil">
        <p ref={timerRef}></p>
        <div className="video-instructions-stencil-div">
          <div>
            {Object.keys(config["video-page"]).includes("REC")
              ? config["video-page"]["REC"]
              : getTranslateText("REC")}
          </div>
        </div>
      </div>

      <div id="window-arc2">
        <img src={carsmall} alt="" className="car" />
        <canvas ref={canvas1} width="100" height="100"></canvas>
      </div>

      <div ref={startRef} className="startPopupStecil">
        <div className="startPopupStecilDiv2">
          <img src={StencilInst} />
        </div>
        <div className="startPopupStecilDiv">
          <div>
            <p style={{ fontWeight: 600 }}>
              {Object.keys(config["video-page"]).includes(
                "Circle around the car to record the video and position the car within the stencil to auto capture photos.",
              )
                ? config["video-page"][
                "Circle around the car to record the video and position the car within the stencil to auto capture photos."
                ]
                : getTranslateText(
                  "Circle around the car to record the video and position the car within the stencil to auto capture photos.",
                )}
            </p>
          </div>
          <button
            onClick={startRecording}
            style={{ backgroundColor: config["colors"]["btn"] }}
          >
            {Object.keys(config["video-page"]).includes("GET STARTED")
              ? config["video-page"]["GET STARTED"]
              : getTranslateText("GET STARTED")}
          </button>
        </div>
      </div>

      <div ref={cardRef} id="display-card">
        <div className="pre-start-card">
          <strong
            style={{
              marginRight: "2px",
              fontSize: "12px",
              transform: "rotate(-90deg)",
            }}
          >
            {config["video-page"]["left-text"]}
          </strong>
          <div className="car-flex">
            <strong
              style={{
                marginBottom: "8px",
                textAlign: "center",
                fontSize: "12px",
              }}
            >
              {config["video-page"]["front-text"]}
            </strong>
            <img ref={imgRef} style={{ width: "12dvw" }} src={initRedImg}></img>
            <strong style={{ marginTop: "10px", fontSize: "12px" }}>
              {config["video-page"]["rear-text"]}
            </strong>
          </div>
          <strong style={{ fontSize: "12px", transform: "rotate(90deg)" }}>
            {config["video-page"]["right-text"]}
          </strong>
          <div style={{ width: "20px" }}></div>
        </div>
        <div className="card-info">
          <div>
            <div className="car-green"></div>
            <b style={{ fontSize: "14px" }}>
              {config["video-page"]["covered-text"]}
            </b>
          </div>
          <div>
            <div
              className="car-red"
              style={{ backgroundColor: "#de524c" }}
            ></div>
            <b style={{ fontSize: "14px" }}>
              {config["video-page"]["notcovered-text"]}
            </b>
          </div>
          <div className="card-note">
            <p
              ref={loaderGuidanceText}
              style={{ width: "100%", fontSize: "14px" }}
            ></p>
            <SafeImage
              id="model-loader"
              src="https://superapp-images-inspektlabs.s3.eu-central-1.amazonaws.com/app-icon/video_model_loader.gif"
              alt="abc"
              fallback={null}
            />
          </div>
        </div>
      </div>

      <div className="chooseRegionStencil" ref={chooseRegionStencil}>
        {skipStencil.length > 0 &&
          Object.keys(config["video-page"]).includes("restrictUser") ? (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Press continue to capture the missed sections",
            )
              ? config["video-page"][
              "Press continue to capture the missed sections"
              ]
              : getTranslateText(
                "Press continue to capture the missed sections",
              )}
          </h3>
        ) : skipStencil.length > 0 ? (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Continue to capture missed sections, or proceed without them.",
            )
              ? config["video-page"][
              "Continue to capture missed sections, or proceed without them."
              ]
              : getTranslateText(
                "Continue to capture missed sections, or proceed without them.",
              )}
          </h3>
        ) : capturedStencil.length > 7 ? (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "All sides of the car is captured",
            )
              ? config["video-page"]["All sides of the car is captured"]
              : getTranslateText("All sides of the car is captured")}
          </h3>
        ) : (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Select left or right to move around the car.",
            )
              ? config["video-page"][
              "Select left or right to move around the car."
              ]
              : getTranslateText(
                "Select left or right to move around the car.",
              )}
          </h3>
        )}
        {skipStencil.length > 0 && (
          <div className="missedList">
            <ul className="missedListUl">
              {skipStencil.map((e, index) => (
                <li key={index}>
                  {Object.keys(config["video-page"]["region"]).includes(e)
                    ? config["video-page"]["region"][e]
                    : getTranslateText(e)}
                </li>
              ))}
            </ul>
          </div>
        )}
        <div className="alignButtons">
          {skipStencil.length > 0 && (
            <div
              style={{ backgroundColor: config["colors"]["btn"] }}
              className="StopRecording"
              onClick={() => {
                missedCheckedStep();
              }}
            >
              <p>
                {Object.keys(config["video-page"]).includes("Continue")
                  ? config["video-page"]["Continue"]
                  : getTranslateText("Continue")}
              </p>
            </div>
          )}
          {Object.keys(config["video-page"]).includes("restrictUser") &&
            config["video-page"]["restrictUser"] &&
            skipStencil.length === 0 &&
            capturedStencil.length > 7 && (
              <div
                style={{ backgroundColor: config["colors"]["btn"] }}
                className="StopRecording"
                onClick={() => {
                  stopRecording();
                }}
              >
                <p>
                  {Object.keys(config["video-page"]).includes("Stop recording")
                    ? config["video-page"]["Stop recording"]
                    : getTranslateText("Stop recording")}
                </p>
              </div>
            )}
          {!(
            Object.keys(config["video-page"]).includes("restrictUser") &&
            config["video-page"]["restrictUser"]
          ) &&
            capturedStencil.length > 7 && (
              <div
                className="StopRecording"
                style={{ backgroundColor: config["colors"]["btn"] }}
                onClick={() => {
                  stopRecording();
                }}
              >
                <p>
                  {Object.keys(config["video-page"]).includes("Stop recording")
                    ? config["video-page"]["Stop recording"]
                    : getTranslateText("Stop recording")}
                </p>
              </div>
            )}
        </div>
        {capturedStencil.length < 7 && (
          <div className="regionModule">
            <div
              className="regionModuleDiv"
              onClick={() => {
                checkStep("previous");
              }}
            >
              <SafeImage
                src={
                  regionIcon[
                  Object.keys(regionStencil)[
                  Object.keys(regionStencil).indexOf(mainRegion) === 0
                    ? 7
                    : Object.keys(regionStencil).indexOf(mainRegion) - 1
                  ]
                  ]
                }
                className="regionModuleimg"
                style={{ border: "1px solid black" }}
              />
              <div
                className="regionButton"
                style={{ backgroundColor: config["colors"]["btn"] }}
              >
                <img
                  style={{
                    height: "18px",
                    width: "30px",
                    transform: "rotate(-180deg)",
                  }}
                  src={nearFarArrow}
                />
                <p>
                  {Object.keys(config["video-page"]).includes("Left")
                    ? config["video-page"]["Left"]
                    : getTranslateText("Left")}
                </p>
              </div>
            </div>
            <div className="regionModuleDiv">
              <SafeImage
                src={regionIcon[mainRegion]}
                style={{ border: "2px solid #13da0e" }}
                className="regionModuleimg"
              />
              <h3 style={{ width: "100%", marginTop: "10%" }}>
                {Object.keys(config["video-page"]["region"]).includes(
                  mainRegion,
                )
                  ? config["video-page"]["region"][mainRegion]
                  : getTranslateText(mainRegion)}
              </h3>
            </div>
            <div
              className="regionModuleDiv"
              onClick={() => {
                checkStep("after");
              }}
            >
              <SafeImage
                className="regionModuleimg"
                src={
                  regionIcon[
                  Object.keys(regionStencil)[
                  Object.keys(regionStencil).indexOf(mainRegion) === 7
                    ? 0
                    : Object.keys(regionStencil).indexOf(mainRegion) + 1
                  ]
                  ]
                }
                style={{ border: "1px solid black" }}
              />
              <div
                className="regionButton"
                style={{ backgroundColor: config["colors"]["btn"] }}
              >
                <p>
                  {Object.keys(config["video-page"]).includes("Right")
                    ? config["video-page"]["Right"]
                    : getTranslateText("Right")}
                </p>
                <img
                  style={{ height: "18px", width: "30px" }}
                  src={nearFarArrow}
                />
              </div>
            </div>
          </div>
        )}
      </div>

      <div ref={warnRef} id="warn-card">
        <Rotate />
        <p className="note">{config["video-page"]["rotateText"]}</p>
      </div>
      {lensDirty && (
        <BlurLensModal
          config={config}
          getTranslateText={getTranslateText}
          inspectionId={inspectionId}
          onClose={() => setLensDirty(false)}
        />
      )}

      <div className="stencil" ref={stencilImageDiv}>
        {Object.keys(regionStencil).map((key) => {
          const Component = regionStencil[key];
          return (
            <div
              key={key}
              id={`stencil-${key}`}
              style={{
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center",
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",
                opacity: 0,
                visibility: "hidden",
                pointerEvents: "none",
                "--stencil-color": "#fff",
              }}
            >
              <Component
                strokeColor="var(--stencil-color)"
                {...(["Side-Left", "Side-Right"].includes(key)
                  ? { preserveAspectRatio: "xMidYMax meet" }
                  : {})}
              />
            </div>
          );
        })}
        {/* Pre-rendered sub-stencils for congested mode — toggled via updateStencilDOM, no React re-render */}
        {/* Rotation disabled — the 0827 artwork is already drawn at the right
            lean, so the extra CSS tilt is commented out below. To bring it back,
            restore the `rotate` values here and the transform in the style block.
            rotate: degrees, CSS-positive = clockwise. Side-Left-Front and
            Side-Right-Back lean 20deg clockwise; Side-Left-Back and
            Side-Right-Front 20deg anti-clockwise. */}
        {[
          // { key: "Side-Right-Front", Component: Side_Right_Front, rotate: -20 },
          // { key: "Side-Right-Back", Component: Side_Right_Back, rotate: 20 },
          // { key: "Side-Left-Front", Component: Side_Left_Front, rotate: 20 },
          // { key: "Side-Left-Back", Component: Side_Left_Back, rotate: -20 },
          { key: "Side-Right-Front", Component: Side_Right_Front },
          { key: "Side-Right-Back", Component: Side_Right_Back },
          { key: "Side-Left-Front", Component: Side_Left_Front },
          { key: "Side-Left-Back", Component: Side_Left_Back },
        ].map(({ key, Component }) => (
          <div
            key={key}
            id={`stencil-${key}`}
            style={{
              display: "flex",
              alignItems: "flex-end",
              justifyContent: "center",
              position: "absolute",
              inset: 0,
              width: "100%",
              height: "100%",
              opacity: 0,
              visibility: "hidden",
              pointerEvents: "none",
              // transform: `rotate(${rotate}deg)`,
              // transformOrigin: "center bottom",
              "--stencil-color": "#fff",
            }}
          >
            <Component
              strokeColor="var(--stencil-color)"
              preserveAspectRatio="xMidYMax meet"
            />
          </div>
        ))}
      </div>

      <img src={HoldSvg} className="holdImage" ref={holdImage} />
      <div className="displayText" ref={displayText}>
        <p></p>
      </div>
      <div
        style={{ position: "relative", height: "100vh", width: "100vw" }}
        ref={detectionBox}
      ></div>
      {/* ---- partData debug panels (commented out) ---- */}
      {/* <p
        style={{
          position: "absolute",
          top: "70px",
          left: 0,
          backgroundColor: "white",
          padding: "5px",
          width: "90%",
        }}
        ref={partData}
      ></p>
      <p
        style={{
          position: "absolute",
          top: "90px",
          left: 0,
          backgroundColor: "transparent",
          color: "red",
          padding: "5px",
          width: "90%",
        }}
        ref={partDataValue}
      ></p>
      <p
        style={{
          position: "absolute",
          top: "190px",
          left: 0,
          backgroundColor: "transparent",
          color: "red",
          padding: "5px",
          width: "90%",
        }}
        ref={partDataValueList}
      ></p> */}
      {/* ---- end partData debug panels ---- */}
      {capturedStencil.length > 0 &&
        capturedStencil.length < 8 &&
        chooseRegionStencil.current.style.display === "none" &&
        holdSkip && (
          <button
            style={{ backgroundColor: config["colors"]["btn"] }}
            className="skip-btn"
            onClick={() => {
              confirmSkipDiv.current.style.display = "flex";
            }}
          >
            <span className="skip-text">
              {Object.keys(config["video-page"]).includes("Skip this region")
                ? config["video-page"]["Skip this region"]
                : getTranslateText("Skip this region")}
            </span>
            <span className="skip-icon">
              <svg viewBox="0 0 24 24" fill="none">
                <path
                  d="M6 6 L12 12 L6 18"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M12 6 L18 12 L12 18"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <rect x="19" y="5" width="2" height="14" rx="1" fill="white" />
              </svg>
            </span>
          </button>
        )}
      <img ref={leftNearArrow} className="leftNearArrow" src={nearFarArrow} />
      <img ref={rightNearArrow} className="rightNearArrow" src={nearFarArrow} />
      <img ref={leftFarArrow} className="leftFarArrow" src={nearFarArrow} />
      <img ref={rightFarArrow} className="rightFarArrow" src={nearFarArrow} />
      <img
        ref={leftArrowVin}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "rotate(-180deg) translate(50%, 50%)",
          display: "none",
        }}
        src={nearFarArrow}
      />
      <img
        ref={rightArrowVin}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "translate(-50%, -50%)",
          display: "none",
        }}
        src={nearFarArrow}
      />
      <img
        ref={upArrow}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "rotate(-90deg) translate(20%, -120%)",
          display: "flex",
        }}
        src={nearFarArrow}
      />
      <img
        ref={downArrow}
        style={{
          height: "20%",
          left: "50%",
          top: "50%",
          position: "absolute",
          transform: "rotate(-270deg)translate(-20%, -120%)",
          display: "flex",
        }}
        src={nearFarArrow}
      />

      <div ref={confirmSkipDiv} className="skipDiv">
        <h3>
          {Object.keys(config["video-page"]).includes(
            "Are you sure you want to skip this section?",
          )
            ? config["video-page"][
            "Are you sure you want to skip this section?"
            ]
            : getTranslateText("Are you sure you want to skip this section?")}
        </h3>
        <div className="skipDivButtons">
          <div
            onClick={() => {
              skipButton();
              confirmSkipDiv.current.style.display = "none";
            }}
          >
            {Object.keys(config["video-page"]).includes("Yes")
              ? config["video-page"]["Yes"]
              : getTranslateText("Yes")}
          </div>
          <div
            onClick={() => {
              confirmSkipDiv.current.style.display = "none";
            }}
          >
            {Object.keys(config["video-page"]).includes("No")
              ? config["video-page"]["No"]
              : getTranslateText("No")}
          </div>
        </div>
      </div>
      <div ref={skipDiv} className="skipDiv">
        {lumacheck ? (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Low light detected. Please start a new inspection, or choose to 'Retry' or 'Skip' this region.",
            )
              ? config["video-page"][
              "Low light detected. Please start a new inspection, or choose to 'Retry' or 'Skip' this region."
              ]
              : getTranslateText(
                "Low light detected. Please start a new inspection, or choose to 'Retry' or 'Skip' this region.",
              )}
          </h3>
        ) : (
          <h3>
            {Object.keys(config["video-page"]).includes(
              "Unable to fit stencil. You can choose to 'Retry' or 'Skip' this region.",
            )
              ? config["video-page"][
              "Unable to fit stencil. You can choose to 'Retry' or 'Skip' this region."
              ]
              : getTranslateText(
                "Unable to fit stencil. You can choose to 'Retry' or 'Skip' this region.",
              )}
          </h3>
        )}
        <div className="skipDivButtons">
          <div
            onClick={() => {
              continueButton();
            }}
          >
            {Object.keys(config["video-page"]).includes("Retry")
              ? config["video-page"]["Retry"]
              : getTranslateText("Retry")}
          </div>
          <div
            onClick={() => {
              skipButton();
            }}
          >
            {Object.keys(config["video-page"]).includes("Skip")
              ? config["video-page"]["Skip"]
              : getTranslateText("Skip")}
          </div>
        </div>
      </div>

      <div
        ref={skipDivFallback}
        className="skipDiv"
        style={{
          width: "90dvw",
          maxWidth: "450px", // Limits width on larger screens
          height: "auto",
          minHeight: "200px",
          zIndex: 10,
          backgroundColor: "#ffffff",
          borderRadius: "20px",
          padding: "30px 24px",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        <h3
          style={{
            fontSize: "1.1rem",
            color: "#2c3e50",
            lineHeight: "1.6",
            margin: "0 0 24px 0",
            fontWeight: "500",
          }}
        >
          {errorType
            ? config["video-page"][
            "It seems that video app is not compatible with your device. Do you want to switch to image app?"
            ] ||
            getTranslateText(
              "It seems that video app is not compatible with your device. Do you want to switch to image app?",
            )
            : config["video-page"][
            "Are you facing any issues with recording the video. Do you want to switch to image app?"
            ] ||
            getTranslateText(
              "Are you facing any issues with recording the video. Do you want to switch to image app?",
            )}
        </h3>

        <div
          className="skipDivButtons"
          style={{
            display: "flex",
            gap: "12px",
            width: "100%",
            marginTop: "auto",
          }}
        >
          {/* Continue Button - Secondary Action */}
          <div
            onClick={() => {
              patLogs("User chose to continue with video module", inspectionId);
              skipDiv.current.style.display = "none";
              // checkForRedirect();
            }}
            style={{
              flex: 1,
              padding: "14px 0",
              borderRadius: "12px",
              backgroundColor: "white",
              color: config["colors"]["secoundaryBtn"]
                ? config["colors"]["secoundaryBtn"]
                : "black",
              border: config["colors"]["secoundaryBtn"]
                ? `2px solid ${config["colors"]["secoundaryBtn"]}`
                : "2px solid black",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: "pointer",
              textAlign: "center",
              transition: "background 0.2s ease",
            }}
          >
            {config["video-page"]["Continue"] || getTranslateText("Continue")}
          </div>

          {/* Switch Button - Primary Action */}
          <div
            onClick={async () => {
              patLogs("User chose to switch to image module", inspectionId);
              // camera closing -> stop recording and upload the video
              stopCarVideoRecordingAndUpload();
              active = false;
              window.stream = null;
              track.stop();
              clearInterval(startTimer);
              await setMandatoryCondition();
              filterPortoModuleList(IMG360CONFIG)
              setScreen("block");
              setCurrentBlock(IMG360CONFIG);
              skipDiv.current.style.display = "none";
            }}
            style={{
              flex: 1,
              padding: "14px 0",
              borderRadius: "12px",
              backgroundColor: config["colors"]["btn"],
              color: "var(--btn-text, #fff)",
              fontSize: "1rem",
              fontWeight: "600",
              cursor: "pointer",
              textAlign: "center",
              transition: "background 0.2s ease",
            }}
          >
            {config["video-page"]["Switch"] || getTranslateText("Switch")}
          </div>
        </div>
      </div>

      <div
        ref={congestedSubDiv}
        style={{
          display: "none",
          width: "90dvw",
          maxWidth: "450px",
          height: "auto",
          minHeight: "200px",
          zIndex: 10,
          backgroundColor: "#ffffff",
          borderRadius: "20px",
          padding: "30px 24px",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        <h3
          style={{
            fontSize: "1.1rem",
            color: "#2c3e50",
            lineHeight: "1.6",
            margin: "0 0 24px 0",
            fontWeight: "500",
          }}
        >
          {getPageText("Select which part of the side to capture")}
        </h3>
        <div
          className="skipDivButtons"
          style={{
            display: "flex",
            gap: "12px",
            width: "100%",
            marginTop: "auto",
          }}
        >
          <div
            onClick={() => {
              const firstKey =
                mainRegion === "Side-Right"
                  ? "Side-Right-Front"
                  : "Side-Left-Front";
              const secondKey =
                mainRegion === "Side-Right"
                  ? "Side-Right-Back"
                  : "Side-Left-Back";
              congestedRef.current = {
                active: true,
                parentRegion: mainRegion,
                keys: [firstKey, secondKey],
                currentIdx: 0,
                results: [null, null],
              };
              updateStencilDOM(firstKey, true, "#fff");
              congestedSubDiv.current.style.display = "none";
            }}
            style={{
              // Compact sizing to match the skip-confirmation popup buttons
              // (.skipDivButtons div: 40px high, small radius).
              width: "40%",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "5px",
              backgroundColor: "white",
              color: config["colors"]["secoundaryBtn"]
                ? config["colors"]["secoundaryBtn"]
                : "black",
              border: config["colors"]["secoundaryBtn"]
                ? `2px solid ${config["colors"]["secoundaryBtn"]}`
                : "2px solid black",
              fontSize: "0.9rem",
              fontWeight: "600",
              cursor: "pointer",
              textAlign: "center",
            }}
          >
            {getPageText(
              mainRegion === "Side-Right"
                ? "Side Right Front"
                : "Side Left Front",
            )}
          </div>
          <div
            onClick={() => {
              const firstKey =
                mainRegion === "Side-Right"
                  ? "Side-Right-Back"
                  : "Side-Left-Back";
              const secondKey =
                mainRegion === "Side-Right"
                  ? "Side-Right-Front"
                  : "Side-Left-Front";
              congestedRef.current = {
                active: true,
                parentRegion: mainRegion,
                keys: [firstKey, secondKey],
                currentIdx: 0,
                results: [null, null],
              };
              updateStencilDOM(firstKey, true, "#fff");
              congestedSubDiv.current.style.display = "none";
            }}
            style={{
              // Compact sizing to match the skip-confirmation popup buttons
              // (.skipDivButtons div: 40px high, small radius).
              width: "40%",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "5px",
              backgroundColor: config["colors"]["btn"],
              color: "white",
              fontSize: "0.9rem",
              fontWeight: "600",
              cursor: "pointer",
              textAlign: "center",
            }}
          >
            {getPageText(
              mainRegion === "Side-Right" ? "Side Right Back" : "Side Left Back",
            )}
          </div>
        </div>
      </div>

      <div
        ref={congestedAreaDiv}
        style={{
          display: "none",
          width: "90dvw",
          maxWidth: "450px",
          // Fixed at 70% of the viewport rather than sized to its contents,
          // so the popup is the same proportion of the screen on every phone.
          // border-box keeps the padding inside that 70% instead of adding to
          // it, and the overflow guard covers the one case the fixed height
          // cannot -- a long translation next to the image on a short
          // landscape screen, which scrolls rather than clipping.
          height: "70dvh",
          boxSizing: "border-box",
          overflowY: "auto",
          zIndex: 10,
          backgroundColor: "#ffffff",
          borderRadius: "20px",
          padding: "20px",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "18px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.25)",
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          fontFamily: "system-ui, -apple-system, sans-serif",
        }}
      >
        {/* Header beside the image rather than above it, which is what keeps
            the popup short. The text takes whatever width is left over and the
            image is capped in both directions, so a narrow phone shrinks the
            image rather than squeezing the text into a column of single
            words. */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
            width: "100%",
            // Takes the height the buttons do not, so the question sits
            // centred in the space above them instead of pinned to the top of
            // a box that is now taller than its contents.
            flex: "1 1 auto",
            minHeight: 0,
          }}
        >
          <img
            src={conjustedImg}
            alt="congested area"
            style={{
              flex: "0 0 auto",
              width: "clamp(64px, 30%, 104px)",
              height: "auto",
              // Holds the image down on a short landscape screen, where 30% of
              // the popup width would otherwise be taller than the viewport
              // can spare.
              maxHeight: "22dvh",
              objectFit: "contain",
              margin: 0,
            }}
          />
          <h3
            style={{
              flex: "1 1 auto",
              // Without this a long translation refuses to wrap and pushes the
              // row wider than the popup.
              minWidth: 0,
              fontSize: "clamp(0.95rem, 4vw, 1.1rem)",
              color: "#2c3e50",
              lineHeight: "1.4",
              margin: 0,
              fontWeight: "500",
              textAlign: "left",
            }}
          >
            {getPageText("Are you in a congested area?")}
          </h3>
        </div>
        <div
          className="skipDivButtons"
          style={{
            display: "flex",
            gap: "12px",
            width: "100%",
          }}
        >
          <div
            onClick={() => {
              patLogs("congested popup - user said yes", inspectionId);
              congestedAreaDiv.current.style.display = "none";
              // Auto-pick the sub-stencil order from where the user came from
              // (last captured stencil); the manual selection popup is only
              // shown when the direction can't be determined.
              const autoOrder = getAutoCongestedOrder();
              if (autoOrder) {
                congestedRef.current = {
                  active: true,
                  parentRegion: mainRegion,
                  keys: autoOrder,
                  currentIdx: 0,
                  results: [null, null],
                };
                updateStencilDOM(autoOrder[0], true, "#fff");
              } else {
                congestedSubDiv.current.style.display = "flex";
              }
            }}
            style={{
              // Compact sizing to match the skip-confirmation popup buttons
              // (.skipDivButtons div: 40px high, small radius).
              width: "40%",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "5px",
              backgroundColor: "white",
              color: config["colors"]["secoundaryBtn"]
                ? config["colors"]["secoundaryBtn"]
                : "black",
              border: config["colors"]["secoundaryBtn"]
                ? `2px solid ${config["colors"]["secoundaryBtn"]}`
                : "2px solid black",
              fontSize: "0.9rem",
              fontWeight: "600",
              cursor: "pointer",
              textAlign: "center",
            }}
          >
            {getPageText("Yes")}
          </div>
          <div
            onClick={() => {
              patLogs("congested popup - user said no", inspectionId);
              congestedAreaDiv.current.style.display = "none";
              updateStencilDOM(
                currentStencil,
                true,
                stateTrackers.current.stencilColor,
              );
            }}
            style={{
              // Compact sizing to match the skip-confirmation popup buttons
              // (.skipDivButtons div: 40px high, small radius).
              width: "40%",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "5px",
              backgroundColor: config["colors"]["btn"],
              color: "white",
              fontSize: "0.9rem",
              fontWeight: "600",
              cursor: "pointer",
              textAlign: "center",
            }}
          >
            {getPageText("No")}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StencilVideo;
